import {
  makeSelectIsAuditar,
  makeSelectPracticesValidSelect,
  makeSelectStartTimeSelectedPreparationPristine,
} from './../app/selectors';
import {
  makeSelectIdTypePracticeSelected,
  makeSelectStartDateTimeSelectedPreparation,
} from './../app/selectors';
import { call, put, select, takeEvery, takeLatest } from 'redux-saga/effects';
import ActionTypes from 'store/practicas/actionTypes';
import { ResponseFetcher } from 'utils/fetcher/types';
import { RequestStatusTypes, RouteTypes, TxtTypes } from 'consts';
import { makeSelectTokenBearerToken } from 'store/oauth/selectors';
import {
  makeSelectCourseCreateSelected,
  makeSelectCoursesSelected,
  makeSelectDateMaxSelected,
  makeSelectDateMinSelected,
  makeSelectFinishDateTimeSelectedJourney,
  makeSelectFinishDateTimeSelectedService,
  makeSelectInstructorsSelected,
  makeSelectMinutesPracticeSelected,
  makeSelectNumTurnoSelected,
  makeSelectObservacionesInstructor,
  makeSelectObservacionesAlumno,
  makeSelectPracticaAuditoriaSeleccionada,
  makeSelectPracticaEditar,
  makeSelectSelectedJourney,
  makeSelectSelectedProvince,
  makeSelectSelectedStudents,
  makeSelectSocietiesSelected,
  makeSelectStartDateTimeSelectedJourney,
  makeSelectStartDateTimeSelectedService,
  makeSelectStatePracticeSelected,
  makeSelectStateType,
  makeSelectStationFinSelected,
  makeSelectStationIniSelected,
  makeSelectTrainSelected,
  makeSelectTypeServiceSelected,
  makeSelectUserList,
  makeSelectUsername,
  makeSelectVehicleSelected,
  makeSelectPracticaRechazadaSeleccionada,
  makeSelectPracticaReclamadaSeleccionada,
} from 'store/app/selectors';
import {
  setDestinySelected,
  setFinishDateTimeSelectedJourney,
  setFinishDateTimeSelectedService,
  setModalDraftType,
  setMsgSubmit,
  setPracticaCreada,
  setSelectedAlumno,
  setSelectedCourse,
  setSelectedInstructors,
  setStartDateTimeSelectedJourney,
  setStartDateTimeSelectedService,
  setStationSelected,
  setTrainSelected,
  setTurnSelected,
  setIdTypePracticeSelected,
  setTypeServiceSelected,
  setVehicleSelected,
  setStartDateTimeSelectedPreparation,
  setObservacionesAlumno,
  setStartTimeSelectedJourneyPristine,
  setFinishTimeSelectedJourneyPristine,
  setStartTimeSelectedPreparationPristine,
  setStartTimeSelectedServicePristine,
  setFinishTimeSelectedServicePristine,
  setObservacionesInstructor,
  setDateMinSelected,
  setDateMaxSelected,
} from 'store/app/actions';
import { makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected } from 'store/usuarios/selectors';
import {
  AlumnoAuditoria,
  AlumnoPractica,
  AlumnoData,
  CrearPractica,
  CrearPracticaRequest,
  CursoAuditoria,
  CursoPractica,
  FormadorCurso,
  Estacion,
  EstadoCurso,
  EstadoPractica,
  ExportExcelData,
  FechaMaximaPractica,
  FechaMinimaPractica,
  GetAlumnoAuditoriaRequest,
  GetCursosActivosJornadaRequest,
  GetCursosAuditoriaRequest,
  GetEstacionesRequest,
  GetEstadosCursosRequest,
  GetEstadosPracticaRequest,
  GetFechaMinimaPracticaRequest,
  GetFilterAlumnoPracticaRequest,
  GetFilterAlumnosByInstructoresRequest,
  GetFilterCursoPracticaRequest,
  GetFilterCursosByAlumnosRequest,
  GetFormadoresCursoRequest,
  GetFilterCursosByInstructoresRequest,
  GetInfoUsersRequest,
  GetInstructoresPracticasRequest,
  GetJornadasUsuarioRequest,
  GetPracticasAuditoriaCountRequest,
  GetPracticasAuditoriaRequest,
  GetPracticasByJornadaRequest,
  GetPracticasCountRequest,
  GetPracticaSeleccionadaRequest,
  GetPracticasRequest,
  GetProvinciaRequest,
  GetSociedadesRequest,
  GetTipoServicioRequest,
  GetTiposPracticaRequest,
  InfoUsers,
  InstructorData,
  InstructorPractica,
  JornadaUsuario,
  PostAnularPracticaRequest,
  PostAuditoriaRequest,
  PostRechazarPracticaRequest,
  PostReclamarPracticaRequest,
  PostValidarPracticaRequest,
  Practica,
  PracticaAuditoria,
  PracticaPayload,
  PracticasCount,
  PracticaSeleccionada,
  PracticeRequestSagaOptions,
  Provincias,
  Sociedad,
  TipoPractica,
  TipoServicio,
  GetFilterInstructoresByAlumnosRequest,
} from 'store/practicas/types';
import {
  crearPracticaRequest,
  getAlumnosAuditoriaRequest,
  getCursosActivosJornadaRequest,
  getCursosAuditoriaRequest,
  getEstacionesRequest,
  getEstadosCursosRequest,
  getEstadosPracticaRequest,
  getFechaMaximaPracticaRequest,
  getFechaMinimaPracticaRequest,
  getFilterAlumnoPracticaRequest,
  getFilterCursosByInstructoresRequest,
  getFilterCursoPracticaRequest,
  getFormadoresCursosRequest,
  getInfoUsersRequest,
  getInstructoresPracticasRequest,
  getJornadasUsuarioRequest,
  getPracticasAuditoriaCountRequest,
  getPracticasAuditoriaRequest,
  getPracticasByJornadaRequest,
  getPracticasCountRequest,
  getPracticasCountRequest2,
  getPracticaSeleccionadaRequest,
  //getPracticasRequest,
  getPracticasRequest2,
  getProvinciaAuditoriaRequest,
  getSociedadesRequest,
  getTipoServicioRequest,
  getTiposPracticaRequest,
  postAnularPracticaRequest,
  postAuditoriaRequest,
  postRechazarPracticaRequest,
  postReclamarPracticaRequest,
  postValidarPracticaRequest,
  getFilterCursosByAlumnosRequest,
  getFilterInstructoresByAlumnosRequest,
  getFilterAlumnosByInstructoresRequest,
  getCursosAuditoriaByAlumnosRequest,
} from 'store/practicas/requests';
import {
  resetSort,
  setAlumnosAuditoria,
  setAlumnosPractica,
  setCrearPracticaRequestStatus,
  setCursosActivosJornada,
  setCursosAuditoria,
  setCursosPractica,
  setformadoresCursos,
  setElementsPerPage,
  setEstaciones,
  setEstadosCursos,
  setEstadosPracticas,
  setFechaMaximaPractica,
  setFechaMinimaPractica,
  setGetAlumnosAuditoriaRequestStatus,
  setGetAuditPracticesRequestStatusLoading,
  setGetCursosActivosJornadaRequestStatus,
  setGetCursosAuditoriaRequestStatus,
  setGetEstacionesRequestStatus,
  setGetEstadosCursosRequestStatus,
  setGetEstadosPracticaRequestStatus,
  setGetFechaMaximaPracticaRequestStatus,
  setGetFechaMinimaPracticaRequestStatus,
  setGetFilterAlumnoPracticaRequestStatus,
  setGetFilterCursoPracticaRequestStatus,
  setGetFilterAlumnosByInstructoresRequestStatus,
  setGetFilterCursosByAlumnosRequestStatus,
  setGetFilterCursosByInstructoresRequestStatus,
  setGetFilterInstructoresByAlumnosRequestStatus,
  setGetFormadorCursoRequestStatus,
  setGetInstructoresPracticasRequestStatus,
  setGetJornadasUsuarioRequestStatus,
  setGetPracticasAuditoriaRequestStatus,
  setGetPracticasByJornadaRequestStatus,
  setGetPracticasCountRequestStatus,
  setGetPracticaSeleccionadaRequestStatus,
  setGetPracticasRequestStatus,
  setGetPracticasRequestStatusLoading,
  setGetProvinciasRequestStatus,
  setGetTipoServicioRequestStatus,
  setGetTiposPracticaRequestStatus,
  setInstructoresPracticas,
  setJornadasUsuario,
  setPages,
  setPostAnularPracticaRequestStatus,
  setPostAuditoriaRequestStatus,
  setPostRechazarPracticaRequestStatus,
  setPostReclamarPracticaRequestStatus,
  setPostValidarPracticaRequestStatus,
  setPracticas,
  setPracticas2,
  setPracticasAuditoria,
  setPracticasAuditoriaCount,
  setPracticasByJornada,
  setPracticasCount,
  setPracticasCount2,
  setPracticasSeleccionada,
  setProvincias,
  setProvinciasAuditoria,
  setSelectedPage,
  setSociedades,
  setTiposPractica,
  setTiposServicio,
  setTodasPracticasAuditoria,
  setUserInfo,
  setInstructores,
} from 'store/practicas/actions';
import {
  makeSelectElementsPerPage,
  makeSelectFechaMaximaPractica,
  makeSelectFechaMinimaPractica,
  makeSelectGetPracticasRequestStatus,
  makeSelectListCount,
  makeSelectPracticasAuditoriaCount,
  makeSelectPracticaSeleccionada,
  makeSelectPracticasList,
  makeSelectSelectedCursosAuditoria,
  makeSelectSelectedPage,
  makeSelectSelectedProvinciasAuditoria,
  makeSelectSelectedSociedadAuditoria,
  makeSelectSorting,
  makeSelectSortingSort,
} from './selectors';
import { setGetInfoUsersRequestStatus } from 'store/usuarios/actions';
import { EstacionesServicio, InstructorEdit } from 'store/app/types';
import { userProfile } from 'utils/profilesIndex';

import { DatosPerfilesUsuario } from '../usuarios/types';
import {
  exportToExcel,
  addSingleQuotesToStudentsDniChain,
  responseMessage,
} from '../../utils/practiceUtils';
import { getHeaderAuditExcel } from '../../containers/Table/utils';
import {
  autoUpdateSocietySelected,
  getInfoUsersRequestSaga,
} from '../app/sagas';
import { exportDataTableExcel } from 'utils/export-excel';
import {
  parseDate,
  parsePracticeStatus,
  parseTime,
} from 'utils/parsePractices';
import { hasAccess } from 'utils/listUtils';
import { RequestStatus } from '../../types';
import { getInfoUsers, initAppSaga } from '../usuarios/sagas';
import {
  getTimeFromDate,
  removeSecondsAndMilliseconds,
} from '../../utils/dateTimeUtils';
import { getDefaultFechaMaximaPractica, getMessageFromResponse } from './utils';

export default function* sagas() {
  yield takeEvery(ActionTypes.REMOVE_FILTER_AUDITORIA, initAppSaga);

  yield takeEvery(
    [ActionTypes.SUBMIT_FILTERS, ActionTypes.SET_ELEMENTS_PER_PAGE],
    submitFiltersSaga
  );
  yield takeEvery(
    ActionTypes.POST_ANULAR_PRACTICA_REQUEST,
    postAnularPracticaRequestSaga
  );

  yield takeEvery(ActionTypes.POST_AUDITORIA_REQUEST, postAuditoriaRequestSaga);

  yield takeEvery(
    ActionTypes.POST_AUDITORIA_EDIT_REQUEST,
    postAuditoriaEditRequestSaga
  );

  yield takeEvery(
    ActionTypes.POST_RECHAZAR_PRACTICA_REQUEST,
    postRechazarPracticaRequestSaga
  );

  yield takeEvery(
    ActionTypes.POST_RECHAZAR_PRACTICA_EDIT_REQUEST,
    postRechazarPracticaEditRequestSaga
  );

  yield takeEvery(
    ActionTypes.POST_RECLAMAR_PRACTICA_REQUEST,
    postReclamarPracticaRequestSaga
  );

  yield takeEvery(
    ActionTypes.POST_VALIDAR_PRACTICA_REQUEST,
    postValidarPracticaRequestSaga
  );

  yield takeEvery(
    ActionTypes.GET_FILTER_CURSO_PRACTICA_REQUEST,
    getFilterCursoPracticaRequestSaga
  );

  yield takeEvery(
    ActionTypes.GET_FILTER_ALUMNO_PRACTICA_REQUEST,
    getFilterAlumnoPracticaRequestSaga
  );

  yield takeEvery(
    ActionTypes.GET_FILTER_CURSOS_BY_INSTRUCTORES_REQUEST,
    getFilterCursosByInstructoresRequestSaga
  );

  yield takeEvery(
    ActionTypes.GET_FILTER_CURSOS_BY_ALUMNOS_REQUEST,
    getFilterCursosByAlumnosRequestSaga
  );

   yield takeEvery(
    ActionTypes.GET_FILTER_CURSOS_BY_ALUMNOS_AUDITORIA_REQUEST,
    getFilterCursosByAlumnosAuditoriaRequestSaga
  );

  yield takeEvery(
    ActionTypes.GET_FILTER_INSTRUCTORES_BY_ALUMNOS_REQUEST,
    getFilterInstructoresByAlumnosRequestSaga
  );

  yield takeEvery(
    ActionTypes.GET_FILTER_ALUMNOS_BY_INSTRUCTORES_REQUEST,
    getFilterAlumnosByInstructoresRequestSaga
  );
  yield takeEvery(
    ActionTypes.GET_FORMADOR_CURSO_REQUEST,
    getFormadorCursoRequestSaga
  );
  yield takeEvery(
    ActionTypes.GET_FILTER_ALUMNO_PRACTICA_REQUEST,
    getFilterAlumnoPracticaRequestSaga
  );

  yield takeEvery(
    ActionTypes.GET_ESTADOS_CURSOS_REQUEST,
    getEstadosCursosRequestSaga
  );

  yield takeEvery(
    ActionTypes.GET_FECHA_MINIMA_PRACTICA_REQUEST,
    getFechaMinimaPracticaRequestSaga
  );

  yield takeEvery(
    ActionTypes.GET_FECHA_MAXIMA_PRACTICA_REQUEST,
    getFechaMaximaPracticaRequestSaga
  );

  yield takeEvery(
    ActionTypes.GET_PRACTICAS_SELECCIONADA_REQUEST,
    getPracticaSeleccionadaRequestSaga
  );

  yield takeEvery(
    ActionTypes.GET_CURSOS_ACTIVOS_JORNADA_REQUEST,
    getCursosActivosJornadaRequestSaga
  );

  yield takeEvery(
    ActionTypes.GET_INSTRUCTORES_PRACTICAS_REQUEST,
    getInstructoresPracticasRequestSaga
  );

  yield takeEvery(ActionTypes.CREAR_PRACTICA_REQUEST, crearPracticaRequestSaga);

  yield takeEvery(
    ActionTypes.GET_PRACTICAS_COUNT_REQUEST,
    getPracticasCountRequestSaga
  );

  yield takeEvery(
    ActionTypes.GET_PRACTICAS_BY_JORNADA_REQUEST,
    getPracticasByJornadaRequestSaga
  );

  yield takeEvery(
    ActionTypes.GET_PRACTICAS_AUDITORIA_COUNT_REQUEST,
    getPracticasAuditoriaCountRequestSaga
  );

  yield takeLatest(
    [
      ActionTypes.GET_PRACTICAS_REQUEST,
      ActionTypes.SET_GET_PRACTICAS_UPDATE,
      ActionTypes.SET_SELECTED_PAGE,
    ],
    getListSaga
  );

  yield takeEvery(
    ActionTypes.GET_PRACTICAS_AUDITORIA_REQUEST,
    getPracticasAuditoriaRequestSaga
  );

  yield takeEvery(
    ActionTypes.GET_ESTADOS_PRACTICA_REQUEST,
    getEstadosPracticaRequestSaga
  );

  yield takeEvery(
    ActionTypes.GET_TIPO_SERVICIO_REQUEST,
    getTipoServicioRequestSaga
  );

  yield takeEvery(ActionTypes.GET_SOCIEDADES_REQUEST, getSociedadesRequestSaga);

  yield takeEvery(
    ActionTypes.GET_JORNADAS_USUARIO_REQUEST,
    getJornadasUsuarioRequestSaga
  );

  yield takeEvery(ActionTypes.GET_ESTACIONES_REQUEST, getEstacionesRequestSaga);

  yield takeEvery(
    ActionTypes.GET_TIPOS_PRACTICA_REQUEST,
    getTiposPracticaRequestSaga
  );

  yield takeEvery(
    ActionTypes.SET_GET_PRACTICAS_AUDITORIA_UPDATE,
    getPracticasAuditoriaRequestSaga
  );

  yield takeEvery(
    ActionTypes.GET_TODAS_PRACTICAS_AUDITORIA_RREQUEST,
    getTodasPracticasAuditoriaRequestSaga
  );

  yield takeEvery(
    ActionTypes.SET_SELECTED_CURSOS_AUDITORIA,
    getAlumnoAuditoriaRequestSaga
  );

  yield takeLatest(ActionTypes.SET_SORT, getListRequestSaga);
  yield takeEvery(ActionTypes.EXPORT_EXCEL, exportExcelSaga);

  yield takeLatest(
    ActionTypes.SET_SELECTED_SOCIEDAD_AUDITORIA,
    autoUpdateSocietySelected
  );

  yield takeEvery(
    ActionTypes.SET_SELECTED_PROVINCIA_AUDITORIA,
    getCursosAuditoriaRequestSaga
  );
  yield takeEvery(
    ActionTypes.SET_SELECTED_PROVINCIA_AUDITORIA,
    getAlumnoAuditoriaRequestSaga
  );

  yield takeLatest(
    ActionTypes.SET_GET_PRACTICAS_REQUEST_STATUS_LOADING,
    getPracticasRequestSaga
  );

  // Practicas remake

  yield takeEvery(ActionTypes.GET_PRACTICAS, getPracticasRequest2Saga);

  yield takeEvery(
    ActionTypes.GET_PRACTICAS_COUNT,
    getPracticasCountRequest2Saga
  );

  yield takeEvery(
    ActionTypes.GET_PRACTICAS_EXCEL,
    getExcelPracticasRequestSaga
  );

  yield takeEvery(
    ActionTypes.GET_PRACTICAS_HORAS_FORMACION_INSTRUCTOR_EXCEL,
    getExcelPracticasHorasFormacionInstructorRequestSaga
  );
  yield takeLatest(
    ActionTypes.SET_GET_AUDIT_PRACTICES_REQUEST_STATUS_LOADING,
    getPracticasAuditoriaRequestSaga
  );
}

export function* postAnularPracticaRequestSaga() {
  try {
    const usuario = yield select(makeSelectUsername());
    const perfilSelected = yield select(
      makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected()
    );

    const practicaSeleccionada = yield select(makeSelectPracticaSeleccionada());
    const payload: PostAnularPracticaRequest = {
      usuario: usuario,
      perfilId: perfilSelected?.ID_PERFIL,
      practicaId: practicaSeleccionada.CUERPO_FICHA.ID_PRACTICA,
    };
    const bearerToken = yield select(makeSelectTokenBearerToken());
    const response: ResponseFetcher<CrearPractica> = yield call(
      postAnularPracticaRequest,
      payload,
      bearerToken
    );

    if (response.ok) {
      yield put(setMsgSubmit(response.data.MESSAGE));
      yield put(setModalDraftType('success'));
      yield put(
        setPostAnularPracticaRequestStatus({
          status: RequestStatusTypes.Success,
          code: response.code,
          url: response.url,
        })
      );
    } else {
      yield put(
        setMsgSubmit(
          'Error al anular la práctica' + response.data?.moreInformation
        )
      );
      yield put(setModalDraftType('alert'));
      yield put(
        setPostAnularPracticaRequestStatus({
          status: RequestStatusTypes.Error,
          code: response.code,
          message: TxtTypes.TXT_DEFAULT_MESSAGE_ERROR,
          url: response.url,
        })
      );
      throw new Error(`Error: ${ActionTypes.POST_ANULAR_PRACTICA_REQUEST}`);
    }
  } catch (err) {
    console.error(err);
  }
}

export function* postAuditoriaEditRequestSaga() {
  try {
    const usuario = yield select(makeSelectUsername());
    const perfilSelected = yield select(
      makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected()
    );

    const practicaSeleccionada = yield select(makeSelectPracticaSeleccionada());
    const payload: PostAuditoriaRequest = {
      usuario: usuario,
      perfilId: perfilSelected.ID_PERFIL,
      practicasIds: practicaSeleccionada.CUERPO_FICHA.ID_PRACTICA.toString(),
    };

    const bearerToken = yield select(makeSelectTokenBearerToken());
    const response: ResponseFetcher<CrearPractica> = yield call(
      postAuditoriaRequest,
      payload,
      bearerToken
    );

    if (response.ok) {
      yield put(setMsgSubmit('Práctica auditada correctamente'));
      yield put(setModalDraftType('success'));
      yield put(
        setPostAuditoriaRequestStatus({
          status: RequestStatusTypes.Success,
          code: response.code,
          url: response.url,
        })
      );
    } else {
      yield put(
        setPostAuditoriaRequestStatus({
          status: RequestStatusTypes.Error,
          code: response.code,
          message: TxtTypes.TXT_DEFAULT_MESSAGE_ERROR,
          url: response.url,
        })
      );
      throw new Error(`Error: ${ActionTypes.POST_AUDITORIA_REQUEST}`);
    }
  } catch (err) {
    console.error(err);
  }
}

export function* postAuditoriaRequestSaga() {
  try {
    const usuario = yield select(makeSelectUsername());
    const perfilSelected = yield select(
      makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected()
    );

    const practicaId = yield select(makeSelectPracticaAuditoriaSeleccionada());
    const payload: PostAuditoriaRequest = {
      usuario: usuario,
      perfilId: perfilSelected.ID_PERFIL,
      practicasIds: practicaId,
    };
    const bearerToken = yield select(makeSelectTokenBearerToken());
    const response: ResponseFetcher<CrearPractica> = yield call(
      postAuditoriaRequest,
      payload,
      bearerToken
    );

    if (response.ok) {
      yield put(setMsgSubmit('Prácticas auditadas correctamente'));
      yield put(setModalDraftType('success'));
      yield put(
        setPostAuditoriaRequestStatus({
          status: RequestStatusTypes.Success,
          code: response.code,
          url: response.url,
        })
      );
    } else {
      yield put(
        setPostAuditoriaRequestStatus({
          status: RequestStatusTypes.Error,
          code: response.code,
          message: TxtTypes.TXT_DEFAULT_MESSAGE_ERROR,
          url: response.url,
        })
      );
      throw new Error(`Error: ${ActionTypes.POST_AUDITORIA_REQUEST}`);
    }
  } catch (err) {
    console.error(err);
  }
}

/**
  Este es el método original de rechazar prácticas desde detalles se quedara como esta
  habra que hacer modificaciones en el resto para el otro método.
  Se debera llamar postRechazarPracticaEditRequestSaga y mirar las llamadas
 */
export function* postRechazarPracticaEditRequestSaga() {
  try {
    const usuario = yield select(makeSelectUsername());
    const perfilSelected = yield select(
      makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected()
    );
    const practicaId = yield select(makeSelectPracticaEditar());
    const observaciones_instructor = yield select(
      makeSelectObservacionesInstructor()
    );
    const payload: PostRechazarPracticaRequest = {
      usuario,
      perfilId: perfilSelected?.ID_PERFIL,
      observacionesInstructor: observaciones_instructor
        ? observaciones_instructor
        : '',
      practicasId: practicaId,
    };
    const bearerToken = yield select(makeSelectTokenBearerToken());
    const response: ResponseFetcher<null> = yield call(
      postRechazarPracticaRequest,
      payload,
      bearerToken
    );

    const auxResponseData = response.data as any;
    const errorSMSMessage =
      auxResponseData.ERROR_SMS ?? auxResponseData.MESSAGE_SMS ?? null;

    if (response.ok) {
      yield put(
        setMsgSubmit(
          `Práctica rechazada con éxito. ${errorSMSMessage
            ? `Se ha enviado SMS al instructor con mensaje: ${errorSMSMessage}`
            : ''
          }`
        )
      );
      yield put(setModalDraftType('success'));
      yield put(
        setPostRechazarPracticaRequestStatus({
          status: RequestStatusTypes.Success,
          code: response.code,
          url: response.url,
        })
      );
    } else {
      yield put(
        setMsgSubmit(
          `Práctica no rechazada. ${auxResponseData.MESSAGE !== '' ? auxResponseData.MESSAGE : ''
          }`
        )
      );
      yield put(setModalDraftType('alert'));
      yield put(
        setPostRechazarPracticaRequestStatus({
          status: RequestStatusTypes.Error,
          code: response.code,
          message: TxtTypes.TXT_DEFAULT_MESSAGE_ERROR,
          url: response.url,
        })
      );
      throw new Error(`Error: ${ActionTypes.POST_RECHAZAR_PRACTICA_REQUEST}`);
    }
  } catch (err) {
    console.error(err);
  }
}

/*
  Este método es el antiguo pero modificado para la tabla y el details,
  anteriormente solo era datails, debera llamarse post postRechazarPracticaRequestSaga
  como el de auditar para la tabla (habra que fijarse en el auditar tambien)
*/
export function* postRechazarPracticaRequestSaga() {
  try {
    const usuario = yield select(makeSelectUsername());
    const perfilSelected = yield select(
      makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected()
    );
    const practicasId: string = yield select(
      makeSelectPracticaRechazadaSeleccionada()
    );
    const observaciones_instructor = yield select(
      makeSelectObservacionesInstructor()
    );

    const payload: PostRechazarPracticaRequest = {
      usuario,
      perfilId: perfilSelected?.ID_PERFIL,
      observacionesInstructor: observaciones_instructor
        ? observaciones_instructor
        : '',
      practicasId,
    };
    const bearerToken = yield select(makeSelectTokenBearerToken());
    const response: ResponseFetcher<CrearPractica> = yield call(
      postRechazarPracticaRequest,
      payload,
      bearerToken
    );

    if (response.ok) {
      yield call(setPostRechazarSuccessMessage, response);
      yield call(setPostRechazarSuccessStatus, response);
      return;
    }

    yield call(setPostRechazarErrorStatus, response);
    throw new Error(`Error: ${ActionTypes.POST_RECHAZAR_PRACTICA_REQUEST}`);
  } catch (err) {
    console.error(err);
  }
}

export function* postReclamarPracticaRequestSaga() {
  try {
    const usuario = yield select(makeSelectUsername());
    const perfilSelected = yield select(
      makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected()
    );
    const { practicasId, idAlumno, fechaInicioJornada } = yield call(
      getReclamarContext
    );

    const payload: PostReclamarPracticaRequest = {
      usuario,
      perfilId: perfilSelected?.ID_PERFIL,
      practicasId,
    };
    const bearerToken = yield select(makeSelectTokenBearerToken());
    const response: ResponseFetcher<CrearPractica> = yield call(
      postReclamarPracticaRequest,
      payload,
      bearerToken
    );

    if (response.ok) {
      yield call(
        handlePostReclamarOkResponse,
        response,
        idAlumno,
        fechaInicioJornada
      );
      yield call(setPostReclamarSuccessStatus, response);
      return;
    }

    yield call(setPostReclamarErrorStatus, response);
    throw new Error(`Error: ${ActionTypes.POST_RECLAMAR_PRACTICA_REQUEST}`);
  } catch (err) {
    console.error(err);
  }
}

export function* postValidarPracticaRequestSaga() {
  try {
    const usuario = yield select(makeSelectUsername());
    const perfilSelected = yield select(
      makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected()
    );

    let practicasId = yield select(makeSelectPracticesValidSelect());

    if (practicasId === '') {
      const practicaSeleccionada = yield select(
        makeSelectPracticaSeleccionada()
      );
      practicasId = `${practicaSeleccionada.CUERPO_FICHA.ID_PRACTICA}`;
    }

    const payload: PostValidarPracticaRequest = {
      usuario: usuario,
      perfilId: perfilSelected?.ID_PERFIL,
      practicasId,
    };
    const bearerToken = yield select(makeSelectTokenBearerToken());
    const response: ResponseFetcher<CrearPractica> = yield call(
      postValidarPracticaRequest,
      payload,
      bearerToken
    );

    if (response.ok) {
      if (!response.data.STATUS_OK) {
        yield put(
          setMsgSubmit(
            'Las prácticas que pueden ser validadas tienen que tener el estado Pendiente de validar o Reclamadas'
          )
        );
        yield put(setModalDraftType('alert'));
      }

      if (response.data.STATUS_OK) {
        if (response.data.STATUS_OK.length === 1) {
          yield put(
            setMsgSubmit(
              responseMessage(response.data, 'Práctica validada correctamente')
            )
          );
        }
        if (response.data.STATUS_OK.length > 1) {
          yield put(
            setMsgSubmit(
              responseMessage(
                response.data,
                'Prácticas validadas correctamente'
              )
            )
          );
        }
        yield put(setModalDraftType('success'));
      }
      yield put(
        setPostValidarPracticaRequestStatus({
          status: RequestStatusTypes.Success,
          code: response.code,
          url: response.url,
        })
      );
    } else {
      yield put(
        setMsgSubmit(
          'Error al validar la práctica.' + response.data?.moreInformation
        )
      );
      yield put(setModalDraftType('alert'));
      yield put(
        setPostValidarPracticaRequestStatus({
          status: RequestStatusTypes.Error,
          code: response.code,
          message: TxtTypes.TXT_DEFAULT_MESSAGE_ERROR,
          url: response.url,
        })
      );
      throw new Error(`Error: ${ActionTypes.POST_VALIDAR_PRACTICA_REQUEST}`);
    }
  } catch (err) {
    console.error(err);
  }
}

export function* getFilterCursoPracticaRequestSaga(params: any) {
  try {
    const usuario = yield select(makeSelectUsername());
    const perfilSelected = yield select(
      makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected()
    );
    const payload: GetFilterCursoPracticaRequest = {
      usuario,
      perfilId: perfilSelected?.ID_PERFIL,
      sociedades: '',
      ...params.payload,
    };
    const response: ResponseFetcher<CursoPractica[]> = yield call(
      getFilterCursoPracticaRequest,
      payload,
      ''
      /* bearerToken, */
    );

    if (response.ok) {
      yield put(setCursosPractica(response.data));
      yield put(
        setGetFilterCursoPracticaRequestStatus({
          status: RequestStatusTypes.Success,
          code: response.code,
          url: response.url,
        })
      );
    } else {
      yield put(
        setGetFilterCursoPracticaRequestStatus({
          status: RequestStatusTypes.Error,
          code: response.code,
          message: TxtTypes.TXT_DEFAULT_MESSAGE_ERROR,
          url: response.url,
        })
      );
      throw new Error(
        `Error: ${ActionTypes.GET_FILTER_CURSO_PRACTICA_REQUEST}`
      );
    }
  } catch (err) {
    console.error(err);
  }
}
export function* getFormadorCursoRequestSaga(params: any) {
  try {

if(params.payload.length > 0){

  const idsArray = params.payload; // array de numeros tipo Long
  const idsString = idsArray.join(','); // convierte el array a string separado por comas

  const usuario = yield select(makeSelectUsername());
  const perfilSelected = yield select(
      makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected()
    );
  const payload: GetFormadoresCursoRequest = {
       usuario: usuario,
      perfilId: perfilSelected?.ID_PERFIL,
      idCursos: idsString,
    };


    //llamada correcta, comentar la definición de payload anterior
    const response: ResponseFetcher<FormadorCurso[]> = yield call(
      getFormadoresCursosRequest,
      payload,
      ''
    );


    if (response.ok) {
      yield put(setformadoresCursos(response.data));
      yield put(
        setGetFormadorCursoRequestStatus({
          status: RequestStatusTypes.Success,
          code: response.code,
          url: response.url,
        })
      );
    } else {
      yield put(
        setGetFormadorCursoRequestStatus({
          status: RequestStatusTypes.Error,
          code: response.code,
          message: TxtTypes.TXT_DEFAULT_MESSAGE_ERROR,
          url: response.url,
        })
      );
      throw new Error(
        `Error: ${ActionTypes.GET_FORMADOR_CURSO_REQUEST}`
      );
    }
  }} catch (err) {
    console.error(err);
  }
}

export function* getAlumnoAuditoriaRequestSaga() {
  try {
    const usuario = yield select(makeSelectUsername());
    const perfilSelected = yield select(
      makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected()
    );
    let provi: any = [];
    const provinciasSelected = yield select(
      makeSelectSelectedProvinciasAuditoria()
    );
    const selectedCourses = yield select(makeSelectSelectedCursosAuditoria());

    if (provinciasSelected !== '') {
      provi = provinciasSelected?.map((prov: any) => [...provi, prov.value]);
    }

    const sociedadAudit = yield select(makeSelectSelectedSociedadAuditoria());

    const payload: GetAlumnoAuditoriaRequest = {
      sociedades: getSociedadesAuditoriaValue(perfilSelected, sociedadAudit),
      provincias: provi.toString() ? provi.toString() : '',
      cursos: selectedCourses.join(),
      usuario,
      perfilId: perfilSelected?.ID_PERFIL,
    };
    const bearerToken = yield select(makeSelectTokenBearerToken());
    const response: ResponseFetcher<AlumnoAuditoria[]> = yield call(
      getAlumnosAuditoriaRequest,
      payload,
      bearerToken
    );

    if (response.ok) {
      yield put(setAlumnosAuditoria(response.data));
      yield put(
        setGetAlumnosAuditoriaRequestStatus({
          status: RequestStatusTypes.Success,
          code: response.code,
          url: response.url,
        })
      );
    } else {
      yield put(
        setGetAlumnosAuditoriaRequestStatus({
          status: RequestStatusTypes.Error,
          code: response.code,
          message: TxtTypes.TXT_DEFAULT_MESSAGE_ERROR,
          url: response.url,
        })
      );
      throw new Error(`Error: ${ActionTypes.GET_ALUMNOS_AUDITORIA_REQUEST}`);
    }
  } catch (err) {
    console.error(err);
  }
}

export function* getCursosAuditoriaRequestSaga() {
  try {
    const usuario = yield select(makeSelectUsername());
    const perfilSelected = yield select(
      makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected()
    );
    let provi: any = [];
    const provinciasSelected = yield select(
      makeSelectSelectedProvinciasAuditoria()
    );
    if (provinciasSelected !== '') {
      provi = provinciasSelected?.map((prov: any) => [...provi, prov.value]);
    }
    const sociedadAudit = yield select(makeSelectSelectedSociedadAuditoria());
    const payload: GetCursosAuditoriaRequest = {
      sociedades: getSociedadesAuditoriaValue(perfilSelected, sociedadAudit),
      provincias: provi.toString() ? provi.toString() : '',
      usuario,
      perfilId: perfilSelected?.ID_PERFIL,
    };
    const bearerToken = yield select(makeSelectTokenBearerToken());
    const response: ResponseFetcher<CursoAuditoria[]> = yield call(
      getCursosAuditoriaRequest,
      payload,
      bearerToken
    );

    if (response.ok) {
      yield put(setCursosAuditoria(response.data));
      yield put(
        setGetCursosAuditoriaRequestStatus({
          status: RequestStatusTypes.Success,
          code: response.code,
          url: response.url,
        })
      );
    } else {
      yield put(
        setGetCursosAuditoriaRequestStatus({
          status: RequestStatusTypes.Error,
          code: response.code,
          message: TxtTypes.TXT_DEFAULT_MESSAGE_ERROR,
          url: response.url,
        })
      );
      throw new Error(`Error: ${ActionTypes.GET_CURSO_AUDITORIA_REQUEST}`);
    }
  } catch (err) {
    console.error(err);
  }
}

export function* getFilterAlumnoPracticaRequestSaga(params) {
  try {
    yield put(setSelectedAlumno([]));
    const usuario = yield select(makeSelectUsername());
    const perfilSelected = yield select(
      makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected()
    );

    const payload: GetFilterAlumnoPracticaRequest = {
      usuario,
      perfilId: perfilSelected?.ID_PERFIL,
      sociedades: '',
      cursos: '',
      ...params.payload,
    };
    const response: ResponseFetcher<AlumnoPractica[]> = yield call(
      getFilterAlumnoPracticaRequest,
      payload,
      ''
      /* bearerToken, */
    );
    if (response.ok) {
      yield put(setAlumnosPractica(response.data));
      yield put(
        setGetFilterAlumnoPracticaRequestStatus({
          status: RequestStatusTypes.Success,
          code: response.code,
          url: response.url,
        })
      );
    } else {
      yield put(
        setGetFilterAlumnoPracticaRequestStatus({
          status: RequestStatusTypes.Error,
          code: response.code,
          message: TxtTypes.TXT_DEFAULT_MESSAGE_ERROR,
          url: response.url,
        })
      );
      throw new Error(
        `Error: ${ActionTypes.GET_FILTER_ALUMNO_PRACTICA_REQUEST}`
      );
    }
  } catch (err) {
    console.error(err);
  }
}

export function* getFilterCursosByInstructoresRequestSaga(params) {
  try {
    const usuario = yield select(makeSelectUsername());
    const perfilSelected = yield select(
      makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected()
    );

    const payload: GetFilterCursosByInstructoresRequest = {
      usuario,
      perfilId: perfilSelected?.ID_PERFIL,
      instructores: '',
      ...params.payload,
    };
    const response: ResponseFetcher<CursoPractica[]> = yield call(
      getFilterCursosByInstructoresRequest,
      payload,
      ''
      /* bearerToken, */
    );
    if (response.ok) {
      yield put(setCursosPractica(response.data));
      yield put(
        setGetFilterCursosByInstructoresRequestStatus({
          status: RequestStatusTypes.Success,
          code: response.code,
          url: response.url,
        })
      );
    } else {
      yield put(
        setGetFilterCursosByInstructoresRequestStatus({
          status: RequestStatusTypes.Error,
          code: response.code,
          message: TxtTypes.TXT_DEFAULT_MESSAGE_ERROR,
          url: response.url,
        })
      );
      throw new Error(
        `Error: ${ActionTypes.GET_FILTER_CURSOS_BY_INSTRUCTORES_REQUEST}`
      );
    }
  } catch (err) {
    console.error(err);
  }
}

export function* getFilterAlumnosByInstructoresRequestSaga(params) {
  try {
    const usuario = yield select(makeSelectUsername());
    const perfilSelected = yield select(
      makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected()
    );

    const payload: GetFilterAlumnosByInstructoresRequest = {
      usuario,
      perfilId: perfilSelected?.ID_PERFIL,
      instructores: '',
      ...params.payload,
    };
    const response: ResponseFetcher<AlumnoPractica[]> = yield call(
      getFilterAlumnosByInstructoresRequest,
      payload,
      ''
      /* bearerToken, */
    );
    if (response.ok) {
      yield put(setAlumnosPractica(response.data));
      console.log("Respuesta Alumnos por Ins",response)
      yield put(
        setGetFilterAlumnosByInstructoresRequestStatus({
          status: RequestStatusTypes.Success,
          code: response.code,
          url: response.url,
        })
      );
    } else {
      yield put(
        setGetFilterAlumnosByInstructoresRequestStatus({
          status: RequestStatusTypes.Error,
          code: response.code,
          message: TxtTypes.TXT_DEFAULT_MESSAGE_ERROR,
          url: response.url,
        })
      );
      throw new Error(
        `Error: ${ActionTypes.GET_FILTER_ALUMNOS_BY_INSTRUCTORES_REQUEST}`
      );
    }
  } catch (err) {
    console.error(err);
  }
}

export function* getFilterCursosByAlumnosRequestSaga(params) {
  try {
    const usuario = yield select(makeSelectUsername());
    const perfilSelected = yield select(
      makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected()
    );

    const payload: GetFilterCursosByAlumnosRequest = {
      usuario,
      perfilId: perfilSelected?.ID_PERFIL,
      alumnos: '',
      ...params.payload,
    };

    const response: ResponseFetcher<CursoPractica[]> = yield call(
      getFilterCursosByAlumnosRequest,
      payload,
      ''
    );

    if (response.ok) {
      yield put(setCursosPractica(response.data));
      yield put(
        setGetFilterCursosByAlumnosRequestStatus({
          status: RequestStatusTypes.Success,
          code: response.code,
          url: response.url,
        })
      );
    } else {
      yield put(
        setGetFilterCursosByAlumnosRequestStatus({
          status: RequestStatusTypes.Error,
          code: response.code,
          message: TxtTypes.TXT_DEFAULT_MESSAGE_ERROR,
          url: response.url,
        })
      );
      throw new Error(
        `Error: ${ActionTypes.GET_FILTER_CURSOS_BY_ALUMNOS_REQUEST}`
      );
    }
  } catch (err) {
    console.error(err);
  }
}


export function* getFilterCursosByAlumnosAuditoriaRequestSaga(params) {
  try {
    const usuario = yield select(makeSelectUsername());
    const perfilSelected = yield select(
      makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected()
    );
    let provi: any = [];
    const provinciasSelected = yield select(
      makeSelectSelectedProvinciasAuditoria()
    );
    if (provinciasSelected !== '') {
      provi = provinciasSelected?.map((prov: any) => [...provi, prov.value]);
    }
    const sociedadAudit = yield select(makeSelectSelectedSociedadAuditoria());
    const payload: GetCursosAuditoriaRequest = {
      sociedades: getSociedadesAuditoriaValue(perfilSelected, sociedadAudit),
      provincias: provi.toString() ? provi.toString() : '',
      usuario,
      perfilId: perfilSelected?.ID_PERFIL,
      alumnos: params.payload,
    };
    const bearerToken = yield select(makeSelectTokenBearerToken());
    const response: ResponseFetcher<CursoAuditoria[]> = yield call(
      getCursosAuditoriaByAlumnosRequest,
      payload,
      bearerToken
    );

    if (response.ok) {
      yield put(setCursosAuditoria(response.data));
      yield put(
        setGetCursosAuditoriaRequestStatus({
          status: RequestStatusTypes.Success,
          code: response.code,
          url: response.url,
        })
      );
    } else {
      yield put(
        setGetCursosAuditoriaRequestStatus({
          status: RequestStatusTypes.Error,
          code: response.code,
          message: TxtTypes.TXT_DEFAULT_MESSAGE_ERROR,
          url: response.url,
        })
      );
      throw new Error(`Error: ${ActionTypes.GET_CURSO_AUDITORIA_REQUEST}`);
    }
  } catch (err) {
    console.error(err);
  }
}


export function* getFilterInstructoresByAlumnosRequestSaga(params) {
  try {
    const usuario = yield select(makeSelectUsername());
    const perfilSelected = yield select(
      makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected()
    );

    const payload: GetFilterInstructoresByAlumnosRequest = {
      usuario,
      perfilId: perfilSelected?.ID_PERFIL,
      alumnos: '',
      ...params.payload,
    };

    const response: ResponseFetcher<InstructorData[]> = yield call(
      getFilterInstructoresByAlumnosRequest,
      payload,
      ''
    );

    if (response.ok) {
      yield put(setInstructores(response.data));
      console.log("Respuesta Ins por ALumnos",response)
      yield put(
        setGetFilterInstructoresByAlumnosRequestStatus({
          status: RequestStatusTypes.Success,
          code: response.code,
          url: response.url,
        })
      );
    } else {
      yield put(
        setGetFilterInstructoresByAlumnosRequestStatus({
          status: RequestStatusTypes.Error,
          code: response.code,
          message: TxtTypes.TXT_DEFAULT_MESSAGE_ERROR,
          url: response.url,
        })
      );
      throw new Error(
        `Error: ${ActionTypes.GET_FILTER_INSTRUCTORES_BY_ALUMNOS_REQUEST}`
      );
    }
  } catch (err) {
    console.error(err);
  }
}

export function* getEstadosCursosRequestSaga() {
  try {
    const usuario = yield select(makeSelectUsername());
    const perfilSelected = yield select(
      makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected()
    );
    const payload: GetEstadosCursosRequest = {
      usuario,
      perfilId: perfilSelected?.ID_PERFIL,
    };
    const saved = JSON.parse(
      sessionStorage.getItem('savedEstadosCursos') || '{"isSaved": false}'
    );

    if (saved.isSaved === undefined) {
      yield put(setEstadosCursos(saved));
      yield put(
        setGetEstadosCursosRequestStatus({
          status: RequestStatusTypes.Success,
          code: 200,
          url: 'Saved values',
        })
      );
    } else {
      const bearerToken = yield select(makeSelectTokenBearerToken());
      const response: ResponseFetcher<EstadoCurso[]> = yield call(
        getEstadosCursosRequest,
        payload,
        bearerToken
      );

      if (response.ok) {
        sessionStorage.setItem(
          'savedEstadosCursos',
          JSON.stringify(response.data)
        );
        yield put(setEstadosCursos(response.data));
        yield put(
          setGetEstadosCursosRequestStatus({
            status: RequestStatusTypes.Success,
            code: response.code,
            url: response.url,
          })
        );
      } else {
        yield put(
          setGetEstadosCursosRequestStatus({
            status: RequestStatusTypes.Error,
            code: response.code,
            message: TxtTypes.TXT_DEFAULT_MESSAGE_ERROR,
            url: response.url,
          })
        );
        throw new Error(`Error: ${ActionTypes.GET_ESTADOS_CURSOS_REQUEST}`);
      }
    }
  } catch (err) {
    console.error(err);
  }
}

export function* getFechaMinimaPracticaRequestSaga() {
  try {
    const usuario = yield select(makeSelectUsername());
    const perfilSelected = yield select(
      makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected()
    );
    const payload: GetFechaMinimaPracticaRequest = {
      usuario,
      perfilId: perfilSelected?.ID_PERFIL,
    };
    const bearerToken = yield select(makeSelectTokenBearerToken());
    const response: ResponseFetcher<FechaMinimaPractica> = yield call(
      getFechaMinimaPracticaRequest,
      payload,
      bearerToken
    );

    if (response.ok) {
      yield put(setFechaMinimaPractica(response.data));
      yield put(setDateMinSelected(response.data));
      yield put(
        setGetFechaMinimaPracticaRequestStatus({
          status: RequestStatusTypes.Success,
          code: response.code,
          url: response.url,
        })
      );
    } else {
      yield put(
        setGetFechaMinimaPracticaRequestStatus({
          status: RequestStatusTypes.Error,
          code: response.code,
          message: TxtTypes.TXT_DEFAULT_MESSAGE_ERROR,
          url: response.url,
        })
      );
      throw new Error(
        `Error: ${ActionTypes.GET_FECHA_MINIMA_PRACTICA_REQUEST}`
      );
    }
  } catch (err) {
    console.error(err);
  }
}

export function* getFechaMaximaPracticaRequestSaga() {
  try {
    const usuario = yield select(makeSelectUsername());
    const perfilSelected = yield select(
      makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected()
    );
    const payload: GetFechaMinimaPracticaRequest = {
      usuario,
      perfilId: perfilSelected?.ID_PERFIL,
    };

    const bearerToken = yield select(makeSelectTokenBearerToken());
    const response: ResponseFetcher<FechaMaximaPractica> = yield call(
      getFechaMaximaPracticaRequest,
      payload,
      bearerToken
    );

    if (response.ok) {
      yield put(setFechaMaximaPractica(response.data));
      yield put(setDateMaxSelected(response.data));
      yield put(
        setGetFechaMaximaPracticaRequestStatus({
          status: RequestStatusTypes.Success,
          code: response.code,
          url: response.url,
        })
      );
    } else {
      yield put(
        setGetFechaMaximaPracticaRequestStatus({
          status: RequestStatusTypes.Error,
          code: response.code,
          message: TxtTypes.TXT_DEFAULT_MESSAGE_ERROR,
          url: response.url,
        })
      );
      const fechaMaximaPractica = getDefaultFechaMaximaPractica();
      yield put(setFechaMaximaPractica(fechaMaximaPractica));
      throw new Error(
        `Error: ${ActionTypes.GET_FECHA_MAXIMA_PRACTICA_REQUEST}`
      );
    }
  } catch (err) {
    console.error(err);
  }
}

export function* getPracticaSeleccionadaRequestSaga() {
  try {
    const usuario = yield select(makeSelectUsername());
    const isAuditar = yield select(makeSelectIsAuditar());
    const perfilSelected = yield select(
      makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected()
    );
    const practicaId = yield select(makeSelectPracticaEditar());
    const payload: GetPracticaSeleccionadaRequest = {
      usuario,
      perfilId: perfilSelected?.ID_PERFIL,
      practicaId: practicaId,
      isAuditar: isAuditar,
    };
    const bearerToken = yield select(makeSelectTokenBearerToken());
    const response: ResponseFetcher<PracticaSeleccionada> = yield call(
      getPracticaSeleccionadaRequest,
      payload,
      bearerToken
    );

    if (response.ok) {
      yield put(setPracticasSeleccionada(response.data));
      yield put(
        setGetPracticaSeleccionadaRequestStatus({
          status: RequestStatusTypes.Success,
          code: response.code,
          url: response.url,
        })
      );
    } else {
      yield put(
        setGetPracticaSeleccionadaRequestStatus({
          status: RequestStatusTypes.Error,
          code: response.code,
          message: TxtTypes.TXT_DEFAULT_MESSAGE_ERROR,
          url: response.url,
        })
      );
      throw new Error(
        `Error: ${ActionTypes.GET_PRACTICAS_SELECCIONADA_REQUEST}`
      );
    }
  } catch (err) {
    console.error(err);
  }
}

export function* getPracticasByJornadaRequestSaga2(idJornadaArg) {
  try {
    const usuario: string = yield select(makeSelectUsername());
    const perfilSelected: DatosPerfilesUsuario = yield select(
      makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected()
    );
    const payload: GetPracticasByJornadaRequest = {
      usuario: usuario,
      perfilId: perfilSelected?.ID_PERFIL,
      idJornada: idJornadaArg,
    };
    const bearerToken = yield select(makeSelectTokenBearerToken());
    const response: ResponseFetcher<Practica[]> = yield call(
      getPracticasByJornadaRequest,
      payload,
      bearerToken
    );

    if (response.ok) {
      yield put(setPracticasByJornada(response.data));
      yield put(
        setGetPracticasByJornadaRequestStatus({
          status: RequestStatusTypes.Success,
          code: response.code,
          url: response.url,
        })
      );
    } else {
      yield put(
        setGetPracticasByJornadaRequestStatus({
          status: RequestStatusTypes.Error,
          code: response.code,
          message: TxtTypes.TXT_DEFAULT_MESSAGE_ERROR,
          url: response.url,
        })
      );
      throw new Error(
        `Error: ${ActionTypes.GET_CURSOS_ACTIVOS_JORNADA_REQUEST}`
      );
    }
  } catch (err) {
    console.error(err);
  }
}


export function* getPracticaSeleccionadaToEditRequestSaga() {
  yield call(getPracticaSeleccionadaRequestSaga);
  const practicaSeleccionada: PracticaSeleccionada = yield select(
    makeSelectPracticaSeleccionada()
  );

  //obtencion de las practicas de la jornada de la practica seleccionada
  const idJornada =
    (practicaSeleccionada as PracticaSeleccionada)?.CUERPO_FICHA
      ?.ID_JORNADA ?? null;
  yield call(getPracticasByJornadaRequestSaga2, idJornada);

  if (
    !practicaSeleccionada?.CABECERA_FICHA ||
    !practicaSeleccionada?.CUERPO_FICHA
  ) {
    return;
  }

  yield call(setEditJourneyDates, practicaSeleccionada);
  yield call(setEditPreparationDate, practicaSeleccionada);
  yield call(setEditServiceDates, practicaSeleccionada);
  yield call(setEditStations, practicaSeleccionada);
  yield call(setEditInstructorAndObservations, practicaSeleccionada);
  yield call(setEditCourseAndPracticeFields, practicaSeleccionada);
}

export const parseEstaciones = (
  dataCod: any,
  dataDesc: any
): EstacionesServicio | any => {
  const result: EstacionesServicio = {
    label: '',
    value: {
      DESC_ESTACION: '',
      COD_ESTACION: '',
    },
  };
  result.label = dataCod + ' - ' + dataDesc;
  result.value.DESC_ESTACION = dataDesc;
  result.value.COD_ESTACION = ('00000' + dataCod).slice(-5);

  return result;
};
export const parseInstructorsToString = (
  selectedInst: InstructorEdit[] | any
): string => {
  let result: string = '';
  selectedInst.forEach((item: any) => {
    if (item.value) {
      result =
        result === ''
          ? item.value.ID_USUARIO
          : result + ',' + item.value.ID_USUARIO;
    } else {
      result = result === '' ? item : result + ',' + item;
    }
  });

  return result;
};
export const parseInstructor = (
  instructorCod: string
): InstructorEdit[] | any => {
  const result: any[] = [];
  const objectInstructor: InstructorEdit = {
    label: '',
    value: {
      ID_USUARIO: '',
    },
  };
  objectInstructor.label = instructorCod;
  objectInstructor.value.ID_USUARIO = instructorCod;
  result[0] = objectInstructor;

  return instructorCod !== undefined && instructorCod !== '' ? result : null;
};

export function* getCursosActivosJornadaRequestSaga() {
  try {
    const usuario: string = yield select(makeSelectUsername());
    const perfilSelected: DatosPerfilesUsuario = yield select(
      makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected()
    );
    const payload: GetCursosActivosJornadaRequest = {
      usuario: usuario,
      perfilId: perfilSelected?.ID_PERFIL,
      idJornada: '',
    };
    const bearerToken = yield select(makeSelectTokenBearerToken());
    const response: ResponseFetcher<CursoPractica[]> = yield call(
      getCursosActivosJornadaRequest,
      payload,
      bearerToken
    );

    if (response.ok) {
      yield put(setCursosActivosJornada(response.data));
      yield put(
        setGetCursosActivosJornadaRequestStatus({
          status: RequestStatusTypes.Success,
          code: response.code,
          url: response.url,
        })
      );
    } else {
      yield put(
        setGetCursosActivosJornadaRequestStatus({
          status: RequestStatusTypes.Error,
          code: response.code,
          message: TxtTypes.TXT_DEFAULT_MESSAGE_ERROR,
          url: response.url,
        })
      );
      throw new Error(
        `Error: ${ActionTypes.GET_CURSOS_ACTIVOS_JORNADA_REQUEST}`
      );
    }
  } catch (err) {
    console.error(err);
  }
}

export function* getPracticasByJornadaRequestSaga(action) {
  const { resolve, reject } = action.payload || {}; // Extraemos resolve/reject de la acción
  try {
    const usuario: string = yield select(makeSelectUsername());
    const perfilSelected: DatosPerfilesUsuario = yield select(
      makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected()
    );
    const idJornadaSelected: JornadaUsuario = yield select(
      makeSelectSelectedJourney()
    );
    const payload: GetPracticasByJornadaRequest = {
      usuario: usuario,
      perfilId: perfilSelected?.ID_PERFIL,
      idJornada: idJornadaSelected?.ID_JORNADA,
    };
    const bearerToken = yield select(makeSelectTokenBearerToken());
    const response: ResponseFetcher<Practica[]> = yield call(
      getPracticasByJornadaRequest,
      payload,
      bearerToken
    );

    if (response.ok) {
      yield put(setPracticasByJornada(response.data));
      yield put(
        setGetPracticasByJornadaRequestStatus({
          status: RequestStatusTypes.Success,
          code: response.code,
          url: response.url,
        })
      );
      if (resolve) resolve(response.data); // Resolvemos la promesa en caso de éxito
    } else {
      yield put(
        setGetPracticasByJornadaRequestStatus({
          status: RequestStatusTypes.Error,
          code: response.code,
          message: TxtTypes.TXT_DEFAULT_MESSAGE_ERROR,
          url: response.url,
        })
      );
      if (reject) reject(new Error("Error al obtener prácticas")); // Rechazamos la promesa en caso de error
      throw new Error(
        `Error: ${ActionTypes.GET_CURSOS_ACTIVOS_JORNADA_REQUEST}`
      );
    }
  } catch (err) {
    console.error(err);
    if (reject) reject(err); // Rechazamos la promesa si ocurre un error inesperado
  }
}

export function* getInstructoresPracticasRequestSaga() {
  try {
    const usuario = yield select(makeSelectUsername());
    const perfilSelected = yield select(
      makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected()
    );
    const isCreacionPractica =
      window.location.pathname === RouteTypes.CREATE ||
      window.location.pathname.includes(RouteTypes.DETAIL_NO_PARAM);
    const payload: GetInstructoresPracticasRequest = {
      usuario,
      perfilId: perfilSelected?.ID_PERFIL,
      isCreacionPractica,
    };
    const saved = JSON.parse(
      sessionStorage.getItem(
        `savedInstructores-${payload.usuario}-${payload.perfilId}-${payload.isCreacionPractica}`
      ) || '{"isSaved": false}'
    );
    if (saved.isSaved === undefined && saved.length > 0) {
      yield put(setInstructoresPracticas(saved));
    } else {

      const response: ResponseFetcher<InstructorPractica[]> = yield call(
        getInstructoresPracticasRequest,
        payload,
        '' /* bearerToken, */
      );

      if (response.ok) {
        sessionStorage.setItem(
          `savedInstructores-${payload.usuario}-${payload.perfilId}-${payload.isCreacionPractica}`,
          JSON.stringify(response.data)
        );
        yield put(setInstructoresPracticas(response.data));
        yield put(setInstructores([]));
        yield put(
          setGetInstructoresPracticasRequestStatus({
            status: RequestStatusTypes.Success,
            code: response.code,
            url: response.url,
          })
        );
      } else {
        yield put(
          setGetInstructoresPracticasRequestStatus({
            status: RequestStatusTypes.Error,
            code: response.code,
            message: TxtTypes.TXT_DEFAULT_MESSAGE_ERROR,
            url: response.url,
          })
        );
        throw new Error(
          `Error: ${ActionTypes.GET_INSTRUCTORES_PRACTICAS_REQUEST}`
        );
      }
    }
  } catch (err) {
    console.error(err);
  }
}

export function* crearPracticaRequestSaga() {
  try {
    const usuario: string = yield select(makeSelectUsername());
    const perfilSelected: DatosPerfilesUsuario = yield select(
      makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected()
    );
    const journeySelected: JornadaUsuario | null = yield select(
      makeSelectSelectedJourney()
    );
    const startDateTimeSelectedJourney: Date | null = yield select(
      makeSelectStartDateTimeSelectedJourney()
    );
    const finishDateTimeSelectedJourney: Date | null = yield select(
      makeSelectFinishDateTimeSelectedJourney()
    );
    const startDateTimeSelectedService: Date | null = yield select(
      makeSelectStartDateTimeSelectedService()
    );
    const finishDateTimeSelectedService: Date | null = yield select(
      makeSelectFinishDateTimeSelectedService()
    );
    const startDateTimeSelectedPreparation: Date | null = yield select(
      makeSelectStartDateTimeSelectedPreparation()
    );
    const startTimeSelectedPreparationPristine: boolean = yield select(
      makeSelectStartTimeSelectedPreparationPristine()
    );

    removeDateTimeSeconds(startDateTimeSelectedJourney);
    removeDateTimeSeconds(finishDateTimeSelectedJourney);
    removeDateTimeSeconds(startDateTimeSelectedPreparation);
    removeDateTimeSeconds(startDateTimeSelectedService);
    removeDateTimeSeconds(finishDateTimeSelectedService);

    const practicaSeleccionada: PracticaSeleccionada = yield select(
      makeSelectPracticaSeleccionada()
    );
    const data = {
      usuario,
      perfilSelected,
      practicaSeleccionada,
      journey: buildCrearPracticaJourney(journeySelected, practicaSeleccionada),
      startDateJourney: startDateTimeSelectedJourney?.getTime() || null,
      finishDateJourney: finishDateTimeSelectedJourney?.getTime() || null,
      startTimeJourney: startDateTimeSelectedJourney
        ? getTimeFromDate(startDateTimeSelectedJourney)
        : '',
      finishTimeJourney: finishDateTimeSelectedJourney
        ? getTimeFromDate(finishDateTimeSelectedJourney)
        : '',
      idCurso: yield select(makeSelectCourseCreateSelected()),
      startDatePreparation:
        !startTimeSelectedPreparationPristine && startDateTimeSelectedPreparation
          ? startDateTimeSelectedPreparation.getTime()
          : null,
      startTimePreparation:
        !startTimeSelectedPreparationPristine && startDateTimeSelectedPreparation
          ? getTimeFromDate(startDateTimeSelectedPreparation)
          : '',
      startDateService: startDateTimeSelectedService?.getTime() || null,
      finishDateService: finishDateTimeSelectedService?.getTime() || null,
      startTimeService: startDateTimeSelectedService
        ? getTimeFromDate(startDateTimeSelectedService)
        : '',
      finishTimeService: finishDateTimeSelectedService
        ? getTimeFromDate(finishDateTimeSelectedService)
        : '',
      idEstadoPractica: yield select(makeSelectStateType()),
      minPractica: yield select(makeSelectMinutesPracticeSelected()),
      numTurno: yield select(makeSelectNumTurnoSelected()),
      typeService: yield select(makeSelectTypeServiceSelected()),
      numTren: yield select(makeSelectTrainSelected()),
      stationIni: yield select(makeSelectStationIniSelected()),
      stationFin: yield select(makeSelectStationFinSelected()),
      instructors: yield select(makeSelectInstructorsSelected()),
      tipoPractica: yield select(makeSelectIdTypePracticeSelected()),
      vehiculo: yield select(makeSelectVehicleSelected()),
      observacionesAlumno: yield select(makeSelectObservacionesAlumno()),
    };
    const payload = buildCrearPracticaPayload(data);
    const bearerToken = yield select(makeSelectTokenBearerToken());
    const response: ResponseFetcher<CrearPractica> = yield call(
      crearPracticaRequest,
      payload,
      bearerToken
    );

    yield call(handleCrearPracticaResponse, response);
  } catch (err) {
    console.error(err);
  }
}

export function* getPracticasCountRequestSaga() {
  try {
    const usuario = yield select(makeSelectUsername());
    const perfilSelected = yield select(
      makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected()
    );
    const selectedAlumno = yield select(makeSelectSelectedStudents());
    const selectedSocieties = yield select(makeSelectSocietiesSelected());
    const selectedCourses = yield select(makeSelectCoursesSelected());
    const selectedInstructor = yield select(makeSelectInstructorsSelected());
    const selectedInstructoString =
      parseInstructorsToString(selectedInstructor);
    const statePracticeSelected = yield select(
      makeSelectStatePracticeSelected()
    );
    const dateMinSelected: FechaMinimaPractica = yield select(
      makeSelectDateMinSelected()
    );
    const dateMaxSelected = yield select(makeSelectDateMaxSelected());
    const payload: GetPracticasCountRequest = {
      usuario,
      perfilId: perfilSelected?.ID_PERFIL,
      // fechaInicio: calculatedDateMin,
      fechaInicio: dateMinSelected ? dateMinSelected.toString() : '',
      fechaFin: dateMaxSelected ? dateMaxSelected.toString() : '',
      sociedades: selectedSocieties ? selectedSocieties.join() : '',
      estados: statePracticeSelected ? statePracticeSelected : '',
      cursos:
        selectedCourses && Array.isArray(selectedCourses)
          ? selectedCourses.join()
          : '',
      alumnos: selectedAlumno ? selectedAlumno.join() : '',
      instructores:
        selectedInstructor && Array.isArray(selectedInstructor)
          ? `'${selectedInstructoString}'`
          : `'${selectedInstructor}'`,
    };
    const bearerToken = yield select(makeSelectTokenBearerToken());
    const response: ResponseFetcher<PracticasCount> = yield call(
      getPracticasCountRequest,
      payload,
      bearerToken
    );

    if (response.ok) {
      yield put(setPracticasCount(response.data));
      yield put(
        setGetPracticasCountRequestStatus({
          status: RequestStatusTypes.Success,
          code: response.code,
          url: response.url,
        })
      );
    } else {
      yield put(
        setGetPracticasCountRequestStatus({
          status: RequestStatusTypes.Error,
          code: response.code,
          message: TxtTypes.TXT_DEFAULT_MESSAGE_ERROR,
          url: response.url,
        })
      );
      throw new Error(`Error: ${ActionTypes.GET_PRACTICAS_COUNT_REQUEST}`);
    }
  } catch (err) {
    console.error(err);
  }
}

export function* getPracticasAuditoriaCountRequestSaga() {
  try {
    const usuario = yield select(makeSelectUsername());
    const perfilSelected = yield select(
      makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected()
    );
    const selectedAlumno = yield select(makeSelectSelectedStudents());
    //Comprobar si hay alumnos seleccionados
    if (!selectedAlumno?.length) {
      return;
    }

    const selectedSocieties = yield select(
      makeSelectSelectedSociedadAuditoria()
    );
    const selectedCourses = yield select(makeSelectSelectedCursosAuditoria());

    let provi: any = [];
    const provinciasSelected = yield select(makeSelectSelectedProvince());
    if (provinciasSelected !== '') {
      provi = provinciasSelected?.map((prov: any) => [...provi, prov.value]);
    }
    const payload: GetPracticasAuditoriaCountRequest = {
      usuario,
      perfilId: perfilSelected?.ID_PERFIL,
      sociedades: selectedSocieties ? selectedSocieties.join() : '',
      cursos: selectedCourses ? selectedCourses.join() : '',
      alumnos: selectedAlumno ? selectedAlumno.join() : '',
      provincias: provi.toString() ? provi.toString() : '',
    };
    const bearerToken = yield select(makeSelectTokenBearerToken());
    const response: ResponseFetcher<PracticasCount> = yield call(
      getPracticasAuditoriaCountRequest,
      payload,
      bearerToken
    );

    if (response.ok) {
      yield put(setPracticasAuditoriaCount(response.data));
      yield put(
        setGetPracticasCountRequestStatus({
          status: RequestStatusTypes.Success,
          code: response.code,
          url: response.url,
        })
      );
    } else {
      yield put(
        setGetPracticasCountRequestStatus({
          status: RequestStatusTypes.Error,
          code: response.code,
          message: TxtTypes.TXT_DEFAULT_MESSAGE_ERROR,
          url: response.url,
        })
      );
      throw new Error(`Error: ${ActionTypes.GET_PRACTICAS_COUNT_REQUEST}`);
    }
  } catch (err) {
    console.error(err);
  }
}

export function* getProvinciasAuditoriaRequestSaga() {
  try {
    const usuario = yield select(makeSelectUsername());
    const perfilSelected = yield select(
      makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected()
    );
    const sociedadAudit = yield select(makeSelectSelectedSociedadAuditoria());
    const cursosAudit = yield select(makeSelectSelectedCursosAuditoria());
    const payload: GetProvinciaRequest = {
      cursos: cursosAudit ? cursosAudit.join() : '',
      sociedades: getSociedadesAuditoriaValue(perfilSelected, sociedadAudit),
      usuario,
      perfilId: perfilSelected?.ID_PERFIL,
    };
    const bearerToken = yield select(makeSelectTokenBearerToken());
    const response: ResponseFetcher<string[]> = yield call(
      getProvinciaAuditoriaRequest,
      payload,
      bearerToken
    );

    if (response.ok) {
      yield put(setProvinciasAuditoria(response.data));
    } else {
      throw new Error(
        `Error: ${ActionTypes.SET_GET_PROVINCIAS_REQUEST_STATUS}`
      );
    }
  } catch (err) {
    console.error(err);
  }
}

export function* getProvinciasRequestSaga() {
  try {
    const usuario = yield select(makeSelectUsername());
    const perfilSelected = yield select(
      makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected()
    );
    const sociedadAudit = yield select(makeSelectSocietiesSelected());
    const cursosAudit = yield select(makeSelectCoursesSelected());
    const payload: GetProvinciaRequest = {
      cursos: cursosAudit ? cursosAudit.join() : '',
      sociedades: sociedadAudit ? sociedadAudit?.value.ID_SOCIEDAD : '',
      usuario,
      perfilId: perfilSelected?.ID_PERFIL,
    };
    const bearerToken = yield select(makeSelectTokenBearerToken());
    const response: ResponseFetcher<Provincias[]> = yield call(
      getProvinciaAuditoriaRequest,
      payload,
      bearerToken
    );

    if (response.ok) {
      yield put(setProvincias(response.data));
      // Cuando se obtienen provincias seteamos las provincias del filtro de auditar
      yield put(setProvinciasAuditoria(response.data as unknown as string[]));
      yield put(
        setGetProvinciasRequestStatus({
          status: RequestStatusTypes.Success,
          code: response.code,
          url: response.url,
        })
      );
    } else {
      yield put(
        setGetProvinciasRequestStatus({
          status: RequestStatusTypes.Error,
          code: response.code,
          message: TxtTypes.TXT_DEFAULT_MESSAGE_ERROR,
          url: response.url,
        })
      );
      throw new Error(
        `Error: ${ActionTypes.SET_GET_PROVINCIAS_REQUEST_STATUS}`
      );
    }
  } catch (err) {
    console.error(err);
  }
}

export function* getPracticasRequestSaga() {
  yield;
}

export function* makeRequestPractice({
  startCount,
  endCount,
}: PracticeRequestSagaOptions) {
  const savedPageNumber = parseInt(
    sessionStorage.getItem(`pageSelected-${window.location.pathname}`) ?? '1'
  );
  let pageNumber = yield select(makeSelectSelectedPage());
  if (savedPageNumber !== pageNumber) {
    yield put(setSelectedPage(savedPageNumber));
  }
  const savedPageResults = parseInt(
    sessionStorage.getItem(`elementsPerPage-${window.location.pathname}`) ??
    '10'
  );
  let pageResults = yield select(makeSelectElementsPerPage());
  if (savedPageResults !== pageResults) {
    yield put(setElementsPerPage(savedPageResults));
  }
}

export function* makeRequestPracticeAudit() {
  const usuario = yield select(makeSelectUsername());
  const perfilSelected = yield select(
    makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected()
  );

  const practicasAuditoriaCount = yield select(
    makeSelectPracticasAuditoriaCount()
  );
  const selectedCourses = yield select(makeSelectSelectedCursosAuditoria());
  const sociedadAudit = yield select(makeSelectSelectedSociedadAuditoria());

  const selectedAlumno = yield select(makeSelectSelectedStudents());
  const sorting = yield select(makeSelectSorting());
  const sortingSort = yield select(makeSelectSortingSort());

  let provi: any = [];
  const provinciasSelected = yield select(makeSelectSelectedProvince());
  if (provinciasSelected !== '') {
    provi = provinciasSelected?.map((prov: any) => [...provi, prov.value]);
  }
  const payload: GetPracticasAuditoriaRequest = {
    usuario,
    perfilId: perfilSelected?.ID_PERFIL,
    sociedades: getSociedadesAuditoriaValue(perfilSelected, sociedadAudit),
    cursos:
      selectedCourses && Array.isArray(selectedCourses)
        ? selectedCourses.join()
        : '',
    alumnos: selectedAlumno ? selectedAlumno.join() : '',
    provincias: provi.toString() ? provi.toString() : '',
    elemInicio: 0,
    elemFin: practicasAuditoriaCount,
    orden: sorting,
    ascDesc: sortingSort,
  };
  const bearerToken = yield select(makeSelectTokenBearerToken());
  return yield call(getPracticasAuditoriaRequest, payload, bearerToken);
}

export function* getTodasPracticasAuditoriaRequestSaga() {
  try {
    const response = yield call(makeRequestPracticeAudit);

    if (response.ok) {
      yield put(setTodasPracticasAuditoria(response.data));
      // Eliminar lista de auditorías ya que no hacen falta después de descargarlas
      yield put(setTodasPracticasAuditoria([]));
    } else {
      throw new Error(
        `Error: ${ActionTypes.GET_TODAS_PRACTICAS_AUDITORIA_RREQUEST}`
      );
    }
  } catch (err) {
    console.error(err);
  }
}

export function* getPracticasAuditoriaRequestSaga() {
  try {
    const usuario = yield select(makeSelectUsername());
    const perfilSelected = yield select(
      makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected()
    );

    const selectedCourses = yield select(makeSelectSelectedCursosAuditoria());
    const sociedadAudit = yield select(makeSelectSelectedSociedadAuditoria());
    const selectedAlumno = yield select(makeSelectSelectedStudents());

    //Comprobar si hay alumnos seleccionados
    if (!selectedAlumno?.length) {
      return;
    }

    const sorting = yield select(makeSelectSorting());
    const sortingSort = yield select(makeSelectSortingSort());
    const pageNumber = yield select(makeSelectSelectedPage());
    const pageResults = yield select(makeSelectElementsPerPage());
    let provi: any = [];
    const provinciasSelected = yield select(
      makeSelectSelectedProvinciasAuditoria()
    );
    if (provinciasSelected !== '') {
      provi = provinciasSelected?.map((prov: any) => [...provi, prov.value]);
    }
    const payload: GetPracticasAuditoriaRequest = {
      usuario,
      perfilId: perfilSelected?.ID_PERFIL,
      sociedades: getSociedadesAuditoriaValue(perfilSelected, sociedadAudit),
      cursos:
        selectedCourses && Array.isArray(selectedCourses)
          ? selectedCourses.join()
          : '',
      alumnos: selectedAlumno ? selectedAlumno.join() : '',
      provincias: provi.toString() ? provi.toString() : '',
      elemInicio: (pageNumber - 1) * pageResults,
      elemFin: (pageNumber - 1) * pageResults + pageResults,
      orden: sorting ? sorting : '',
      ascDesc: sortingSort,
    };
    const bearerToken = yield select(makeSelectTokenBearerToken());
    const response: ResponseFetcher<PracticaAuditoria[]> = yield call(
      getPracticasAuditoriaRequest,
      payload,
      bearerToken
    );

    if (response.ok) {
      yield put(setPracticasAuditoria(response.data));
      yield call(getInfoUsers);
      yield put(
        setGetPracticasAuditoriaRequestStatus({
          status: RequestStatusTypes.Success,
          code: response.code,
          url: response.url,
        })
      );
    } else {
      yield put(
        setGetPracticasAuditoriaRequestStatus({
          status: RequestStatusTypes.Error,
          code: response.code,
          message: TxtTypes.TXT_DEFAULT_MESSAGE_ERROR,
          url: response.url,
        })
      );
      throw new Error(`Error: ${ActionTypes.GET_PRACTICAS_AUDITORIA_REQUEST}`);
    }
  } catch (err) {
    console.error(err);
  }
}

export function* getEstadosPracticaRequestSaga() {
  try {
    const usuario = yield select(makeSelectUsername());
    const perfilSelected = yield select(
      makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected()
    );
    const payload: GetEstadosPracticaRequest = {
      usuario,
      perfilId: perfilSelected?.ID_PERFIL,
    };
    const saved = JSON.parse(
      sessionStorage.getItem(`estadosPracticas-${perfilSelected?.ID_PERFIL}`) ??
      '{"isSaved": false}'
    );
    if (saved.isSaved === undefined) {
      yield put(setEstadosPracticas(saved));
    } else {
      const response: ResponseFetcher<EstadoPractica[]> = yield call(
        getEstadosPracticaRequest,
        payload,
        /* bearerToken, */
        ''
      );

      if (response.ok) {
        sessionStorage.setItem(
          `estadosPracticas-${perfilSelected?.ID_PERFIL}`,
          JSON.stringify(response.data)
        );
        yield put(setEstadosPracticas(response.data));
        yield put(
          setGetEstadosPracticaRequestStatus({
            status: RequestStatusTypes.Success,
            code: response.code,
            url: response.url,
          })
        );
      } else {
        yield put(
          setGetEstadosPracticaRequestStatus({
            status: RequestStatusTypes.Error,
            code: response.code,
            message: TxtTypes.TXT_DEFAULT_MESSAGE_ERROR,
            url: response.url,
          })
        );
        throw new Error(`Error: ${ActionTypes.GET_ESTADOS_PRACTICA_REQUEST}`);
      }
    }
  } catch (err) {
    console.error(err);
  }
}

export function* getInfoUserRequestSaga() {
  try {
    const usuario = yield select(makeSelectUsername());
    const perfilSelected = yield select(
      makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected()
    );
    const userList = yield select(makeSelectUserList());
    const payload: GetInfoUsersRequest = {
      usuario,
      perfilId: perfilSelected?.ID_PERFIL,
      listadoUsuarios: addSingleQuotesToStudentsDniChain(userList),
    };
    const bearerToken = yield select(makeSelectTokenBearerToken());
    const response: ResponseFetcher<InfoUsers[]> = yield call(
      getInfoUsersRequest,
      payload,
      bearerToken
    );

    if (response.ok) {
      yield put(setUserInfo(response.data));
      yield put(
        setGetInfoUsersRequestStatus({
          status: RequestStatusTypes.Success,
          code: response.code,
          url: response.url,
        })
      );
    } else {
      yield put(
        setGetInfoUsersRequestStatus({
          status: RequestStatusTypes.Error,
          code: response.code,
          message: TxtTypes.TXT_DEFAULT_MESSAGE_ERROR,
          url: response.url,
        })
      );
      throw new Error(
        `Error: ${ActionTypes.SET_GET_INFO_USERS_REQUEST_STATUS}`
      );
    }
  } catch (err) {
    console.error(err);
  }
}

export function* getTipoServicioRequestSaga() {
  try {
    const usuario = yield select(makeSelectUsername());
    const perfilSelected = yield select(
      makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected()
    );
    const payload: GetTipoServicioRequest = {
      usuario,
      perfilId: perfilSelected?.ID_PERFIL,
    };
    const saved = JSON.parse(
      sessionStorage.getItem('savedTiposServicio') || '{"isSaved": false}'
    );
    if (saved.isSaved === undefined) {
      yield put(setTiposServicio(saved));
    } else {
      const bearerToken = yield select(makeSelectTokenBearerToken());
      const response: ResponseFetcher<TipoServicio[]> = yield call(
        getTipoServicioRequest,
        payload,
        bearerToken
      );

      if (response.ok) {
        sessionStorage.setItem(
          'savedTiposServicio',
          JSON.stringify(response.data)
        );
        yield put(setTiposServicio(response.data));
        yield put(
          setGetTipoServicioRequestStatus({
            status: RequestStatusTypes.Success,
            code: response.code,
            url: response.url,
          })
        );
      } else {
        yield put(
          setGetTipoServicioRequestStatus({
            status: RequestStatusTypes.Error,
            code: response.code,
            message: TxtTypes.TXT_DEFAULT_MESSAGE_ERROR,
            url: response.url,
          })
        );
        throw new Error(`Error: ${ActionTypes.GET_TIPO_SERVICIO_REQUEST}`);
      }
    }
  } catch (err) {
    console.error(err);
  }
}

export function* getSociedadesRequestSaga() {
  try {
    const usuario = yield select(makeSelectUsername());
    const perfilSelected = yield select(
      makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected()
    );
    const payload: GetSociedadesRequest = {
      usuario,
      perfilId: perfilSelected?.ID_PERFIL,
    };
    const saved = JSON.parse(
      sessionStorage.getItem('savedSociedades') || '{"isSaved": false}'
    );
    if (saved.isSaved === undefined) {
      yield put(setSociedades(saved));
    } else {
      const response: ResponseFetcher<Sociedad[]> = yield call(
        getSociedadesRequest,
        payload,
        /* bearerToken, */
        ''
      );

      if (response.ok) {
        sessionStorage.setItem(
          'savedSociedades',
          JSON.stringify(response.data)
        );
        yield put(setSociedades(response.data));
      } else {
        throw new Error(`Error: ${ActionTypes.GET_SOCIEDADES_REQUEST}`);
      }
    }
  } catch (err) {
    console.error(err);
  }
}

export function* getJornadasUsuarioRequestSaga() {
  try {
    const usuario = yield select(makeSelectUsername());
    const perfilSelected = yield select(
      makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected()
    );
    const payload: GetJornadasUsuarioRequest = {
      usuario,
      perfilId: perfilSelected?.ID_PERFIL,
    };
    const bearerToken = yield select(makeSelectTokenBearerToken());
    const response: ResponseFetcher<JornadaUsuario[]> = yield call(
      getJornadasUsuarioRequest,
      payload,
      bearerToken
    );

    if (response.ok) {
      yield put(setJornadasUsuario(response.data));
      yield put(
        setGetJornadasUsuarioRequestStatus({
          status: RequestStatusTypes.Success,
          code: response.code,
          url: response.url,
        })
      );
    } else {
      yield put(
        setGetJornadasUsuarioRequestStatus({
          status: RequestStatusTypes.Error,
          code: response.code,
          message: TxtTypes.TXT_DEFAULT_MESSAGE_ERROR,
          url: response.url,
        })
      );
      throw new Error(`Error: ${ActionTypes.GET_JORNADAS_USUARIO_REQUEST}`);
    }
  } catch (err) {
    console.error(err);
  }
}

export function* getEstacionesRequestSaga() {
  try {
    const usuario = yield select(makeSelectUsername());
    const perfilSelected = yield select(
      makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected()
    );
    const payload: GetEstacionesRequest = {
      usuario,
      perfilId: perfilSelected?.ID_PERFIL,
    };
    const saved = JSON.parse(
      sessionStorage.getItem('savedEstaciones') || '{"isSaved": false}'
    );

    if (saved.isSaved === undefined) {
      yield put(setEstaciones(saved));
      yield put(
        setGetEstacionesRequestStatus({
          status: RequestStatusTypes.Success,
          code: 200,
          url: 'Saved value',
        })
      );
    } else {
      const bearerToken = yield select(makeSelectTokenBearerToken());
      const response: ResponseFetcher<Estacion[]> = yield call(
        getEstacionesRequest,
        payload,
        bearerToken
      );

      if (response.ok) {
        sessionStorage.setItem(
          'savedEstaciones',
          JSON.stringify(response.data)
        );
        yield put(setEstaciones(response.data));
        yield put(
          setGetEstacionesRequestStatus({
            status: RequestStatusTypes.Success,
            code: response.code,
            url: response.url,
          })
        );
      } else {
        yield put(
          setGetEstacionesRequestStatus({
            status: RequestStatusTypes.Error,
            code: response.code,
            message: TxtTypes.TXT_DEFAULT_MESSAGE_ERROR,
            url: response.url,
          })
        );
        throw new Error(`Error: ${ActionTypes.GET_ESTACIONES_REQUEST}`);
      }
    }
  } catch (err) {
    console.error(err);
  }
}

export function* getTiposPracticaRequestSaga() {
  try {
    const usuario = yield select(makeSelectUsername());
    const perfilSelected = yield select(
      makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected()
    );
    const payload: GetTiposPracticaRequest = {
      usuario,
      perfilId: perfilSelected?.ID_PERFIL,
    };
    const saved = JSON.parse(
      sessionStorage.getItem('savedTiposPractica') || '{"isSaved": false}'
    );
    if (saved.isSaved === undefined) {
      yield put(setTiposPractica(saved));
    } else {
      const bearerToken = yield select(makeSelectTokenBearerToken());
      const response: ResponseFetcher<TipoPractica[]> = yield call(
        getTiposPracticaRequest,
        payload,
        bearerToken
      );

      if (response.ok) {
        sessionStorage.setItem(
          'savedTiposPractica',
          JSON.stringify(response.data)
        );
        yield put(setTiposPractica(response.data));
        yield put(
          setGetTiposPracticaRequestStatus({
            status: RequestStatusTypes.Success,
            code: response.code,
            url: response.url,
          })
        );
      } else {
        yield put(
          setGetTiposPracticaRequestStatus({
            status: RequestStatusTypes.Error,
            code: response.code,
            message: TxtTypes.TXT_DEFAULT_MESSAGE_ERROR,
            url: response.url,
          })
        );
        throw new Error(`Error: ${ActionTypes.GET_TIPOS_PRACTICA_REQUEST}`);
      }
    }
  } catch (err) {
    console.error(err);
  }
}

export function* submitFiltersSaga() {
  try {
    yield put(resetSort());
    yield call(resetPaginationSaga);
  } catch (err) {
    console.error(err);
  }
}

export function* resetPaginationSaga() {
  yield call(getCountListRequestSaga);
  const count: number = yield select(makeSelectListCount());
  const elementsPerPage: number = yield select(makeSelectElementsPerPage());
  const calculatedElementsPerPage: number = Math.ceil(
    !!count ? count / elementsPerPage : 0
  );
  yield put(setPages(calculatedElementsPerPage));
  const savedPageNumber = parseInt(
    sessionStorage.getItem(`pageSelected-${window.location.pathname}`) ?? '1'
  );
  yield put(setSelectedPage(savedPageNumber));
}

export function* getListRequestSaga() {
  yield call(getCountListRequestSaga);
  switch (window.location.pathname) {
    case `${RouteTypes.AUDIT}`:
      yield call(getPracticasAuditoriaRequestSaga);
      break;
    default:
      break;
  }
}

export function* getCountListRequestSaga() {
  switch (window.location.pathname) {
    case `${RouteTypes.AUDIT}`:
      yield call(getPracticasAuditoriaCountRequestSaga);
      break;
    default:
      break;
  }
}

export function* exportExcelSaga() {
  let response: ResponseFetcher<any> = {
    data: [],
    code: 200,
    ok: true,
    url: '',
  };
  let title: string = '';
  switch (window.location.pathname) {
    case `${RouteTypes.AUDIT}`:
      response = yield call(makeRequestPracticeAudit);
      title = 'Cuaderno de prácticas';
      break;
    case `${RouteTypes.HOME}`:
      response = yield call(makeRequestPractice, {
        startCount: -1,
        endCount: -1,
      });
      title = 'Listado de prácticas';
      break;
    default:
      break;
  }
  if (response.ok) {
    const list = response.data;
    const profileActive = yield select(
      makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected()
    );

    const alumnosIds = list.map((item) => item.ID_ALUMNO).join(',');

    const infoUser = yield call(getInfoUsersRequestSaga, alumnosIds);
    exportToExcel(list, profileActive, getHeaderAuditExcel(), infoUser.data, title);
  }
}

export function* getPracticesSaga() {
  yield put(setGetPracticasRequestStatusLoading());
}

export function* getListSaga() {
  switch (window.location.pathname) {
    case `${RouteTypes.AUDIT}`:
      yield call(getAuditPracticesSaga);
      break;
    case `${RouteTypes.HOME}`:
      yield call(getPracticesSaga);
      break;
    default:
      break;
  }
}

// Practicas remake

export const getUserProfileName = (profileId) => {
  let nombre_perfil: string;

  switch (profileId) {
    case '111':
      nombre_perfil = 'Alumno - Maquinista en prácticas';
      break;
    case '121':
      nombre_perfil = 'Alumno - Becario en prácticas';
      break;
    case '122':
      nombre_perfil = 'Alumno - Aspirante en prácticas';
      break;
    case '123':
      nombre_perfil = 'Alumno - Maquinista Ext. en prácticas';
      break;
    case '211':
      nombre_perfil = 'Maquinista Instructor';
      break;
    case '311':
      nombre_perfil = 'Formador';
      break;
    case '411':
      nombre_perfil = 'Gestor';
      break;
    case '511':
      nombre_perfil = 'Administrador';
      break;
    case '611':
      nombre_perfil = 'Supervisor';
      break;
    case '711':
      nombre_perfil = 'Visualizador';
      break;
    default:
      nombre_perfil = '';
      break;
  }

  return nombre_perfil;
};


const isAuditoriaSociedadProfile = (perfilSelected: DatosPerfilesUsuario): boolean =>
  perfilSelected?.ID_PERFIL === userProfile.administrador ||
  perfilSelected?.ID_PERFIL === userProfile.supervisor ||
  perfilSelected?.ID_PERFIL === userProfile.visualizador;

const getSociedadesAuditoriaValue = (
  perfilSelected: DatosPerfilesUsuario,
  sociedadAudit: any
): string => {
  if (!isAuditoriaSociedadProfile(perfilSelected)) {
    return '';
  }

  return sociedadAudit ? sociedadAudit.join() : '';
};

const formatStationExcel = (
  codEstacion: any,
  descEstacion: any,
  emptyValue: string = ' '
): string => {
  if (!codEstacion && !descEstacion) {
    return emptyValue;
  }

  const codigo = codEstacion && codEstacion !== null ? ' - ' + codEstacion : '';
  const descripcion = descEstacion && descEstacion !== null ? '-' + descEstacion : '';

  return codigo + ' ' + descripcion;
};


const getSmsErrorMessage = (data: any): string | null =>
  data?.ERROR_SMS ?? data?.MESSAGE_SMS ?? null;

const getRechazarErrorMessage = (data: any): string =>
  `Práctica no rechazada. ${data?.MESSAGE !== '' ? data?.MESSAGE : ''}`;

function* setPostRechazarSuccessStatus(response: ResponseFetcher<any>) {
  yield put(
    setPostRechazarPracticaRequestStatus({
      status: RequestStatusTypes.Success,
      code: response.code,
      url: response.url,
    })
  );
}

function* setPostRechazarErrorStatus(response: ResponseFetcher<any>) {
  yield put(setMsgSubmit(getRechazarErrorMessage(response.data as any)));
  yield put(setModalDraftType('alert'));
  yield put(
    setPostRechazarPracticaRequestStatus({
      status: RequestStatusTypes.Error,
      code: response.code,
      message: TxtTypes.TXT_DEFAULT_MESSAGE_ERROR,
      url: response.url,
    })
  );
}

function* setPostRechazarSuccessMessage(response: ResponseFetcher<any>) {
  const statusOk = response.data?.STATUS_OK;

  if (!statusOk?.length) {
    return;
  }

  const errorSMSMessage = getSmsErrorMessage(response.data as any);
  const messagePrefix =
    statusOk.length === 1
      ? 'Práctica rechazada con éxito.'
      : 'Prácticas rechazadas con éxito.';

  yield put(
    setMsgSubmit(
      `${messagePrefix} ${errorSMSMessage
        ? `Se ha enviado SMS al instructor con mensaje: ${errorSMSMessage}`
        : ''
      }`
    )
  );
  yield put(setModalDraftType('success'));
}

function* getReclamarContextFromList(practicasId: string) {
  let idAlumno: string | null = null;
  let fechaInicioJornada: string | null = null;

  if (practicasId.indexOf(',') === -1) {
    const practicas = yield select(makeSelectPracticasList());
    const practicaItem = practicas.find(
      (practica) => practica.ID_PRACTICA.toString() === practicasId
    );

    if (practicaItem) {
      idAlumno = practicaItem.ID_ALUMNO.toString();
      fechaInicioJornada = new Date(
        practicaItem.FECHA_INI_SERVICIO
      ).toLocaleDateString();
    }
  }

  return { practicasId, idAlumno, fechaInicioJornada };
}

function* getReclamarContextFromDetail() {
  const practicaDetalle = yield select(makeSelectPracticaSeleccionada());
  const practicasId = `${practicaDetalle.CUERPO_FICHA.ID_PRACTICA}`;
  const idAlumno = practicaDetalle.CABECERA_FICHA?.ID_ALUMNO ?? null;
  const fechaInicioJornada = practicaDetalle.CUERPO_FICHA?.FECHA_INICIO_JORNADA
    ? new Date(
      practicaDetalle.CUERPO_FICHA.FECHA_INICIO_JORNADA
    ).toLocaleDateString()
    : null;

  return { practicasId, idAlumno, fechaInicioJornada };
}

function* getReclamarContext() {
  const practicasId: string = yield select(
    makeSelectPracticaReclamadaSeleccionada()
  );

  return practicasId
    ? yield call(getReclamarContextFromList, practicasId)
    : yield call(getReclamarContextFromDetail);
}

const getReclamarSmsErrorMessage = (data: any): string | null =>
  data.MESSAGE_ERROR_SMS?.length && data.MESSAGE_ERROR_SMS[0].ERROR_SMS
    ? data.MESSAGE_ERROR_SMS[0].ERROR_SMS
    : null;

function* setReclamarSingleMessage(
  responseData: any,
  errorSMSMessage: string | null,
  idAlumno: string | null,
  fechaInicioJornada: string | null
) {
  let modalMessage = 'Práctica reclamada correctamente';

  if (errorSMSMessage) {
    modalMessage = responseData.STATUS_OK[0].STATUS_OK;
    yield put(setMsgSubmit(modalMessage));
    yield put(setModalDraftType('alert'));
    return;
  }

  if (idAlumno && fechaInicioJornada) {
    modalMessage = responseData.STATUS_OK[0].STATUS_OK;
  }

  yield put(setMsgSubmit(modalMessage));
  yield put(setModalDraftType('success'));
}

function* setReclamarMultipleMessage(errorSMSMessage: string | null) {
  let modalMessage = 'Prácticas reclamadas correctamente';

  if (errorSMSMessage) {
    modalMessage += `. ${errorSMSMessage}`;
    yield put(setMsgSubmit(modalMessage));
    yield put(setModalDraftType('alert'));
    return;
  }

  modalMessage += `. Se han enviado SMS a cada uno de los instructores con el aviso correspondiente`;
  yield put(setMsgSubmit(modalMessage));
  yield put(setModalDraftType('success'));
}

function* handlePostReclamarOkResponse(
  response: ResponseFetcher<CrearPractica>,
  idAlumno: string | null,
  fechaInicioJornada: string | null
) {
  if (!response.data.STATUS_OK) {
    yield put(
      setMsgSubmit(
        'Las prácticas que pueden ser reclamadas tienen que tener el estado Pendiente de validar o Reclamadas'
      )
    );
    yield put(setModalDraftType('alert'));
    return;
  }

  const auxResponseData = response.data as any;
  const errorSMSMessage = getReclamarSmsErrorMessage(auxResponseData);

  if (response.data.STATUS_OK.length === 1) {
    yield call(
      setReclamarSingleMessage,
      auxResponseData,
      errorSMSMessage,
      idAlumno,
      fechaInicioJornada
    );
  }

  if (response.data.STATUS_OK.length > 1) {
    yield call(setReclamarMultipleMessage, errorSMSMessage);
  }
}

function* setPostReclamarSuccessStatus(response: ResponseFetcher<any>) {
  yield put(
    setPostReclamarPracticaRequestStatus({
      status: RequestStatusTypes.Success,
      code: response.code,
      url: response.url,
    })
  );
}

function* setPostReclamarErrorStatus(response: ResponseFetcher<any>) {
  yield put(setMsgSubmit('Error al reclamar la práctica'));
  yield put(setModalDraftType('alert'));
  yield put(
    setPostReclamarPracticaRequestStatus({
      status: RequestStatusTypes.Error,
      code: response.code,
      message: TxtTypes.TXT_DEFAULT_MESSAGE_ERROR,
      url: response.url,
    })
  );
}

function* setEditJourneyDates(practicaSeleccionada: PracticaSeleccionada) {
  if (practicaSeleccionada.CUERPO_FICHA.FECHA_INICIO_JORNADA) {
    yield put(
      setStartDateTimeSelectedJourney(
        new Date(practicaSeleccionada.CUERPO_FICHA.FECHA_INICIO_JORNADA)
      )
    );
    yield put(setStartTimeSelectedJourneyPristine(false));
  }

  if (practicaSeleccionada.CUERPO_FICHA.FECHA_FIN_JORNADA) {
    yield put(
      setFinishDateTimeSelectedJourney(
        new Date(practicaSeleccionada.CUERPO_FICHA.FECHA_FIN_JORNADA)
      )
    );
    yield put(setFinishTimeSelectedJourneyPristine(false));
  }
}

function* setEditPreparationDate(practicaSeleccionada: PracticaSeleccionada) {
  const dateTimeSelectedPreparation =
    (practicaSeleccionada?.CUERPO_FICHA as any)?.FECHA_INI_PUESTA_DISP ??
    practicaSeleccionada?.CUERPO_FICHA?.FECHA_INICIO_JORNADA;

  if (dateTimeSelectedPreparation) {
    yield put(
      setStartDateTimeSelectedPreparation(new Date(dateTimeSelectedPreparation))
    );
    yield put(setStartTimeSelectedPreparationPristine(false));
    return;
  }

  yield put(
    setStartDateTimeSelectedPreparation(
      new Date(practicaSeleccionada.CUERPO_FICHA.FECHA_INICIO_JORNADA)
    )
  );
  yield put(setStartTimeSelectedPreparationPristine(true));
}

function* setEditServiceDates(practicaSeleccionada: PracticaSeleccionada) {
  if (practicaSeleccionada.CUERPO_FICHA.FECHA_INICIO_SERVICIO) {
    yield put(
      setStartDateTimeSelectedService(
        new Date(practicaSeleccionada.CUERPO_FICHA.FECHA_INICIO_SERVICIO)
      )
    );
    yield put(setStartTimeSelectedServicePristine(false));
  }

  if (practicaSeleccionada.CUERPO_FICHA.FECHA_FIN_SERVICIO) {
    yield put(
      setFinishDateTimeSelectedService(
        new Date(practicaSeleccionada.CUERPO_FICHA.FECHA_FIN_SERVICIO)
      )
    );
    yield put(setFinishTimeSelectedServicePristine(false));
  }
}

function* setEditStations(practicaSeleccionada: PracticaSeleccionada) {
  const cuerpoFicha = practicaSeleccionada.CUERPO_FICHA;

  if (cuerpoFicha.CODIGO_ESTACION_INICIO && cuerpoFicha.DESCRIPCION_ESTACION_INICIO) {
    yield put(
      setStationSelected(
        parseEstaciones(
          cuerpoFicha.CODIGO_ESTACION_INICIO,
          cuerpoFicha.DESCRIPCION_ESTACION_INICIO
        )
      )
    );
  }

  if (cuerpoFicha.CODIGO_ESTACION_FIN && cuerpoFicha.DESCRIPCION_ESTACION_FIN) {
    yield put(
      setDestinySelected(
        parseEstaciones(
          cuerpoFicha.CODIGO_ESTACION_FIN,
          cuerpoFicha.DESCRIPCION_ESTACION_FIN
        )
      )
    );
  }
}

function* setEditInstructorAndObservations(
  practicaSeleccionada: PracticaSeleccionada
) {
  const cuerpoFicha = practicaSeleccionada.CUERPO_FICHA;

  if (cuerpoFicha.MATRICULA_INSTRUCTOR) {
    yield put(setSelectedInstructors(parseInstructor(cuerpoFicha.MATRICULA_INSTRUCTOR)));
  }

  if (cuerpoFicha.OBSERVACIONES_INSTRUCTOR) {
    yield put(setObservacionesInstructor(cuerpoFicha.OBSERVACIONES_INSTRUCTOR));
  }

  if (cuerpoFicha.OBSERVACIONES_ALUMNO) {
    yield put(setObservacionesAlumno(cuerpoFicha.OBSERVACIONES_ALUMNO));
  }
}

function* setEditCourseAndPracticeFields(
  practicaSeleccionada: PracticaSeleccionada
) {
  const cuerpoFicha = practicaSeleccionada.CUERPO_FICHA;

  if (practicaSeleccionada.CABECERA_FICHA.ID_CURSO) {
    yield put(setSelectedCourse(practicaSeleccionada.CABECERA_FICHA.ID_CURSO));
  }

  if (cuerpoFicha.ID_TIPO_PRACTICA) {
    yield put(setIdTypePracticeSelected(cuerpoFicha.ID_TIPO_PRACTICA));
  }

  if (cuerpoFicha.ID_SERVICIO) {
    yield put(setTypeServiceSelected(cuerpoFicha.ID_SERVICIO));
  }

  if (cuerpoFicha.VEHICULO) {
    yield put(setVehicleSelected(cuerpoFicha.VEHICULO));
  }

  if (cuerpoFicha.NUMERO_TREN) {
    yield put(setTrainSelected(cuerpoFicha.NUMERO_TREN.toString()));
  }

  if (cuerpoFicha.NUMERO_TURNO) {
    yield put(setTurnSelected(cuerpoFicha.NUMERO_TURNO.toString()));
  }
}

const removeDateTimeSeconds = (dateValue: Date | null) => {
  if (dateValue) {
    removeSecondsAndMilliseconds(dateValue);
  }
};

const buildCrearPracticaJourney = (
  journeySelected: JornadaUsuario | null,
  practicaSeleccionada: PracticaSeleccionada
): string => {
  if (journeySelected) {
    return journeySelected.ID_JORNADA;
  }

  return practicaSeleccionada?.CUERPO_FICHA?.ID_JORNADA || '';
};


const valueToStringOrNull = (value: any): string | null =>
  value ? value?.toString() : null;

const dateValueToStringOrNull = (value: any): string | null =>
  value?.toString() ?? null;

const prefixedValueOrNull = (value: any, prefix: string): string | null =>
  value ? prefix.concat(value) : null;

const selectedStationCode = (station: any): string | null =>
  station ? station?.value?.COD_ESTACION?.toString() : null;

const selectedStationDescription = (station: any): string | null =>
  station ? station?.value?.DESC_ESTACION : null;

const selectedInstructorId = (instructors: any): string | null =>
  Array.isArray(instructors) && instructors.length > 0
    ? instructors[0].value.ID_USUARIO
    : null;

const buildCrearPracticaPayload = (data: any): CrearPracticaRequest => ({
  usuario: data.usuario,
  perfilId: data.perfilSelected?.ID_PERFIL,
  practica: {
    CABECERA: {
      ID_JORNADA: data.journey || null,
      ID_ALUMNO: data.usuario,
      FECHA_INI_JORNADA: dateValueToStringOrNull(data.startDateJourney),
      FECHA_FIN_JORNADA: dateValueToStringOrNull(data.finishDateJourney),
      HORA_INI_JORNADA: data.startTimeJourney,
      HORA_FIN_JORNADA: data.finishTimeJourney,
      ID_CURSO: valueToStringOrNull(data.idCurso),
    },
    CUERPO: {
      ID_PRACTICA: valueToStringOrNull(
        data.practicaSeleccionada?.CUERPO_FICHA?.ID_PRACTICA
      ),
      ID_ALUMNO: data.usuario,
      ID_CURSO: valueToStringOrNull(data.idCurso),
      FECHA_INI_SERVICIO: dateValueToStringOrNull(data.startDateService),
      FECHA_FIN_SERVICIO: dateValueToStringOrNull(data.finishDateService),
      HORA_INI_SERVICIO: data.startTimeService,
      HORA_FIN_SERVICIO: data.finishTimeService,
      FECHA_INI_PUESTA_DISP: dateValueToStringOrNull(data.startDatePreparation),
      HORA_INI_PUESTA_DISP: data.startTimePreparation || null,
      ID_EST_PRACTICA: data.idEstadoPractica,
      MIN_PRACTICA: data.minPractica ? Number(data.minPractica) : 0,
      NUM_TURNO: prefixedValueOrNull(data.numTurno, 'X'),
      ID_SERVICIO: data.typeService || null,
      NUM_TREN: prefixedValueOrNull(data.numTren, 'X'),
      COD_ESTACION_INI: selectedStationCode(data.stationIni),
      COD_ESTACION_FIN: selectedStationCode(data.stationFin),
      DESC_ESTACION_INI: selectedStationDescription(data.stationIni),
      DESC_ESTACION_FIN: selectedStationDescription(data.stationFin),
      ID_INSTRUCTOR: selectedInstructorId(data.instructors),
      ID_TIPO_PRACTICA: data.tipoPractica || null,
      VEHICULO: prefixedValueOrNull(data.vehiculo, 'X'),
      OBSERVACIONES_ALUMNO: data.observacionesAlumno || null,
    },
  } as PracticaPayload,
});

function* handleCrearPracticaResponse(response: ResponseFetcher<CrearPractica>) {
  if (response.ok && response.data?.STATUS !== 'KO') {
    yield put(setMsgSubmit(response.data?.MESSAGE));
    yield put(setModalDraftType('success'));
    yield put(setPracticaCreada(response.data.ID_PRACTICA));
    yield put(
      setCrearPracticaRequestStatus({
        status: RequestStatusTypes.Success,
        code: response.code,
        url: response.url,
      })
    );
    return;
  }

  const moreInformation = getMessageFromResponse(response.data?.moreInformation);
  const message = getMessageFromResponse(response.data?.MESSAGE);
  const messageInfo = getMessageFromResponse(response.data?.MESSAGE_INFO);
  yield put(
    setMsgSubmit(`Error al crear. ${moreInformation} ${message} ${messageInfo}`)
  );
  yield put(setModalDraftType('alert'));
  yield put(
    setCrearPracticaRequestStatus({
      status: RequestStatusTypes.Error,
      code: response.code,
      message: TxtTypes.TXT_DEFAULT_MESSAGE_ERROR,
      url: response.url,
    })
  );
  throw new Error(`Error: ${ActionTypes.CREAR_PRACTICA_REQUEST}`);
}

const buildExcelPracticaCommonFields1 = (item: any): any[] => [
  item.ID_CURSO,
  item.jornadaRelacionada ? parseDate(item.jornadaRelacionada[0].FECHA_INI_JORNADA) : ' ',
  item.jornadaRelacionada ? parseDate(item.jornadaRelacionada[0].FECHA_FIN_JORNADA) : ' ',
  item.jornadaRelacionada ? parseTime(item.jornadaRelacionada[0].HORA_INI_JORNADA) : ' ',
  item.jornadaRelacionada ? parseTime(item.jornadaRelacionada[0].HORA_FIN_JORNADA) : ' ',
  item.jornadaRelacionada ? item.jornadaRelacionada[0].TOTAL_JORNADA : ' ',
  item.HORA_INI_PUESTA_DISP !== null ? parseTime(item.HORA_INI_PUESTA_DISP) : ' - ',
];

const buildExcelPracticaCommonFields2 = (item: any): any[] => [
  parseTime(item.HORA_INI_SERVICIO),
  parseTime(item.HORA_FIN_SERVICIO),
  item.MIN_PRACTICA,
  item.ID_TIPO_PRACTICA,
  item.NUM_TREN,
  formatStationExcel(item.COD_ESTACION_INI, item.DESC_ESTACION_INI) + ' ',
  formatStationExcel(item.COD_ESTACION_FIN, item.DESC_ESTACION_FIN, ''),
];

const buildExcelInstructorFields = (item: any): any[] => [
  item.ID_INSTRUCTOR ? item.ID_INSTRUCTOR : '',
  item.ID_INSTRUCTOR ? item.NOMBRE_INSTRUCTOR : '',
  item.OBSERVACIONES_INSTRUCTOR !== null
    ? ' - ' + item.OBSERVACIONES_INSTRUCTOR
    : ' No hay observaciones del instructor',
];

const buildExcelUserFields = (item: any): any[] => [
  item.ID_ALUMNO ? item.ID_ALUMNO : '',
  item.ID_ALUMNO ? item.nombre_usuario_parsed : '',
  item.OBSERVACIONES_ALUMNO !== null
    ? ' - ' + item.OBSERVACIONES_ALUMNO
    : ' No hay observaciones del alumno',
  item.usuario_nombre_perfil,
  item.usuarioPerfilRelacionado ? item.usuarioPerfilRelacionado.TIPO_USUARIO : ' ',
  item.usuarioPerfilRelacionado ? item.usuarioPerfilRelacionado.TIPO_IE : ' ',
];

const canSeeInstructorData = (profileActive: any): boolean =>
  !hasAccess(profileActive, [userProfile.instructor]);

const canSeeUserExcelInfo = (profileActive: any): boolean =>
  hasAccess(profileActive, [
    userProfile.gestor,
    userProfile.administrador,
    userProfile.instructor,
    userProfile.formador,
    userProfile.supervisor,
    userProfile.visualizador,
  ]);

const buildExcelPracticaRow = (item: any, profileActive: any): any[] => {
  let data: any[] = [
    ...buildExcelPracticaCommonFields1(item),
    ...buildExcelPracticaCommonFields2(item),
  ];

  if (canSeeInstructorData(profileActive)) {
    data = [...data, ...buildExcelInstructorFields(item)];
  }

  if (canSeeUserExcelInfo(profileActive)) {
    data = [...data, ...buildExcelUserFields(item)];
  }

  return [...data, parsePracticeStatus(item.ID_EST_PRACTICA)];
};

const buildExcelHorasCommonFields = (item: any): any[] => [
  item.ID_CURSO,
  parseDate(item.FECHA_INI_SERVICIO) + ' ' + parseTime(item.HORA_INI_SERVICIO),
  parseDate(item.FECHA_FIN_SERVICIO) + ' ' + parseTime(item.HORA_FIN_SERVICIO),
  item.jornadaRelacionada ? parseTime(item.jornadaRelacionada[0].HORA_INI_JORNADA) : ' ',
  item.jornadaRelacionada ? parseTime(item.jornadaRelacionada[0].HORA_FIN_JORNADA) : ' ',
  item.MIN_PRACTICA,
  item.DESC_PRACTICA,
  item.NUM_TREN +
    ' ' +
    formatStationExcel(item.COD_ESTACION_INI, item.DESC_ESTACION_INI) +
    ' ' +
    formatStationExcel(item.COD_ESTACION_FIN, item.DESC_ESTACION_FIN, ''),
];

const buildExcelHorasInstructorFields = (item: any): any[] => [
  item.ID_INSTRUCTOR ? item.ID_INSTRUCTOR : '',
];

const buildExcelHorasUserFields = (item: any): any[] => [
  item.ID_ALUMNO ? item.ID_ALUMNO : '',
  item.usuario_nombre_perfil,
];

const buildExcelHorasFormacionInstructorRow = (
  item: any,
  profileActive: any
): any[] => {
  let data: any[] = [...buildExcelHorasCommonFields(item)];

  if (canSeeInstructorData(profileActive)) {
    data = [...data, ...buildExcelHorasInstructorFields(item)];
  }

  if (canSeeUserExcelInfo(profileActive)) {
    data = [...data, ...buildExcelHorasUserFields(item)];
  }

  return [...data, parsePracticeStatus(item.ID_EST_PRACTICA)];
};

export function* practicasRequestSaga(params) {
  const usuario = yield select(makeSelectUsername());
  const perfilSelected = yield select(
    makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected()
  );
  const savedPageNumber = parseInt(
    sessionStorage.getItem(`pageSelected-${window.location.pathname}`) ?? '1'
  );
  let pageNumber = yield select(makeSelectSelectedPage());
  if (savedPageNumber !== pageNumber) {
    yield put(setSelectedPage(savedPageNumber));
    pageNumber = savedPageNumber;
  }
  const savedPageResults = parseInt(
    sessionStorage.getItem(`elementsPerPage-${window.location.pathname}`) ??
    '10'
  );
  let pageResults = yield select(makeSelectElementsPerPage());
  if (savedPageResults !== pageResults) {
    yield put(setElementsPerPage(savedPageResults));
    pageResults = savedPageResults;
  }

  const payload: any = {
    usuario,
    perfilId: perfilSelected?.ID_PERFIL,
    alumnos: '',
    ascDesc: '',
    cursos: '',
    estados: '',
    fechaFin: '',
    fechaInicio: '',
    instructores: '',
    orden: '',
    sociedades: '',
    elemInicio: (pageNumber - 1) * pageResults,
    elemFin: (pageNumber - 1) * pageResults + pageResults,
    elemFinal: (pageNumber - 1) * pageResults + pageResults,
    ...params,
  };

  payload.alumnos = addSingleQuotesToStudentsDniChain(payload.alumnos);
  const practicasResponse: ResponseFetcher<any> = yield call(
    getPracticasRequest2,
    payload
  );
  const practicas = practicasResponse.data;
  const alumnosIds =
    Object.keys(practicas).length !== 0 &&
    practicas.map((item) => item.ID_ALUMNO).join(',');
  const infoUsersResponse: ResponseFetcher<any> = yield call(
    getInfoUsersRequestSaga,
    alumnosIds
  );

  const infoUsers = infoUsersResponse.data;
  const practicasParsed: any[] = [];

  Object.keys(practicas).length !== 0 &&
    practicas.forEach((informe) => {
      const user: any = infoUsers.find(
        (user: any) => user.ID_USUARIO === informe.ID_ALUMNO
      );

      if (user) {
        user.nombre_perfil = getUserProfileName(user.ID_PERFIL);
        practicasParsed.push({
          ...informe,
          nombre_usuario_parsed: user.NOMBRE_USUARIO,
          usuario_nombre_perfil: user.nombre_perfil,
          usuario_tipo_ie_parsed: user.TIPO_IE,
          usuario_perfil_parsed: user.PERFIL,
        });
      } else {
        practicasParsed.push({
          ...informe,
          nombre_usuario_parsed: '',
          usuario_tipo_ie_parsed: '',
          usuario_perfil_parsed: '',
        });
      }
    });

  return {
    ok: true,
    data: practicasParsed,
  };
}

export function* getPracticasRequest2Saga(params) {
  try {
    const response: ResponseFetcher<any> = yield call(
      practicasRequestSaga,
      params.payload
    );

    if (response.ok) {
      yield put(setPracticas2(response.data));
    } else {
      throw new Error(`Error: ${ActionTypes.GET_PRACTICAS}`);
    }
  } catch (err) {
    throw new Error(`Error: ${err}`);
  }
}

export function* getPracticasCountRequest2Saga(params) {
  try {
    const usuario = yield select(makeSelectUsername());
    const perfilSelected = yield select(
      makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected()
    );

    const payload: any = {
      usuario,
      perfilId: perfilSelected?.ID_PERFIL,
      alumnos: '',
      cursos: '',
      estados: '',
      fechaFin: '',
      fechaInicio: '',
      instructores: '',
      sociedades: '',
      ...params.payload,
    };

    payload.alumnos = addSingleQuotesToStudentsDniChain(payload.alumnos);

    const response: ResponseFetcher<any> = yield call(
      getPracticasCountRequest2,
      payload
    );

    if (response.ok) {
      yield put(setPracticasCount2(response.data));
      yield put(
        setGetPracticasCountRequestStatus({
          status: RequestStatusTypes.Success,
          code: response.code,
          url: response.url,
        })
      )
    } else {
      yield
      put(setGetPracticasCountRequestStatus({
        status: RequestStatusTypes.Error,
        code: response.code,
        message: TxtTypes.TXT_DEFAULT_MESSAGE_ERROR,
        url: response.url,
      })
      );
      throw new Error(`Error: ${ActionTypes.GET_PRACTICAS_COUNT_REQUEST}`);
    }
  } catch (err) {

  }
}
function addExcelHeaders(literals, headerExcelFile, headerColumsConfig) {
  literals.slice(0, -1).forEach(item => {
    headerExcelFile.push(item.text);
    headerColumsConfig.push({
      label: item.text,
      key: item.text,
      width: 30,
    });
  });
}

export function* getExcelPracticasRequestSaga(params) {
  try {
    const response: ResponseFetcher<any> = yield call(practicasRequestSaga, {
      ...params.payload.filter,
      elemInicio: -1,
      elemFin: -1,
      elemFinal: -1,
    });

    const EXPORT_EXCEL: ExportExcelData = {
      headerExcelFile: [],
      bodyExcelFile: [],
      headerColumsConfig: [],
      title: 'listado_prácticas_' + new Date().getTime().toString(),
    };

    addExcelHeaders(
      params.payload.excelConfig.literals,
      EXPORT_EXCEL.headerExcelFile,
      EXPORT_EXCEL.headerColumsConfig
    );

    const profileActive = params.payload.excelConfig.profile;

    response.data.forEach((item) => {
      EXPORT_EXCEL.bodyExcelFile.push(
        buildExcelPracticaRow(item, profileActive)
      );
    });

    exportDataTableExcel(
      EXPORT_EXCEL.headerExcelFile,
      EXPORT_EXCEL.bodyExcelFile,
      EXPORT_EXCEL.headerColumsConfig,
      EXPORT_EXCEL.title
    );
  } catch (err) {
    console.error(err);
  }
}

export function* getExcelPracticasHorasFormacionInstructorRequestSaga(params) {
  try {
    const response: ResponseFetcher<any> = yield call(practicasRequestSaga, {
      ...params.payload.filter,
      elemInicio: -1,
      elemFin: -1,
      elemFinal: -1,
    });

    const EXPORT_EXCEL: ExportExcelData = {
      headerExcelFile: [],
      bodyExcelFile: [],
      headerColumsConfig: [],
      title: 'listado_prácticas_' + new Date().getTime().toString(),
    };

    addExcelHeaders(
      params.payload.excelConfig.literals,
      EXPORT_EXCEL.headerExcelFile,
      EXPORT_EXCEL.headerColumsConfig
    );

    const profileActive = params.payload.excelConfig.profile;

    response.data.forEach((item) => {
      EXPORT_EXCEL.bodyExcelFile.push(
        buildExcelHorasFormacionInstructorRow(item, profileActive)
      );
    });

    exportDataTableExcel(
      EXPORT_EXCEL.headerExcelFile,
      EXPORT_EXCEL.bodyExcelFile,
      EXPORT_EXCEL.headerColumsConfig,
      EXPORT_EXCEL.title
    );
  } catch (err) {
    console.error(err);
  }
}

export function* getAuditPracticesSaga() {
  yield put(setGetAuditPracticesRequestStatusLoading());
}
